<!-- eslint-disable no-irregular-whitespace -->
<script>
import axios from "axios";
import transformer_38 from "@/transformers/transformer_new";
import Multiselect from "vue-multiselect";
import NumberInput from "@/components/NumberInput";
import zip_codes from "@/data/zip_codes.json";
import loanComponent from '@/loan/loan';
import careerFit from '@/CareerFit/CareerFit.vue';

import state_gross from "@/data/state_gross_up.json";
import _ from "lodash";
import { new_api } from "../../auth_config.json";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/antd.css";
import occupationData from '../CareerFit/occupation';
export default {
  name: "step-app",
  components: {
    NumberInput,
    VueSlider,
    Multiselect,
    loanComponent,
    careerFit,
  },
  props: ["byPass", "dark", "sendDefaultValue"],
  data() {
    return {
      temp: {},
      selectedDwellingSize: "",
      search: '',
      suggestions: [],
      selectedZip: null,
      showSuggestions: false,
      debounceTimeout: null,
      activeCareer: null,
      checked: false,
      grossOrNet: "gross",
      video: "",
      loginPage: true,
      cancelToken: undefined,
      netAmount: 0,
      occupations: [],
      roommatesCount: 0,
      baseRent: 0,
      loanComponentView: false,
      careerFitView: false,
      occupations_val: null,
      annual_gross_salary_level_val: 0,
      annual_gross_salary_level: [
        { text: "Low/Entry", value: 1 },
        { text: "25th Percentile", value: 2 },
        { text: "Median", value: 3 },
        { text: "75th Percentile", value: 4 },
        { text: "High/Experienced", value: 5 },
      ],
      area_level: [
        { text: "Area", value: 1 },
        { text: "State", value: 2 },
        { text: "USA", value: 3 },
      ],
      forget_user_email: "",
      user_email: "",
      user_password: "",
      current_step: 1,
      income_method_val: false,
      max_step: 1,
      rentOrOwn: "rent",
      month_debs: "",
      housingType: "rent",
      moreIncome: "",
      healthInsurance: "no",
      numberOfPeople: "",
      activeTab: [""],
      age: [""],
      zip: "",
      household_members: 1,
      currentActiveAlphabet: "a",
      currentActiveNumber: 1,
      monthlyRent: 0,
      totalMonthly: 0,
      totalDebt: 0,
      isZipSelected: false,
      allowBypass: false,
      creditDebtPayment: null,
      studentLoan: null,
      alimonyPayments: null,
      homeEquityPayment: null,
      childSupportPayments: null,
      estimatedTaxPayments: null,
      otherDebtPayments: null,
      healthPremiumAmount: 0,
      homeIncomeAmount1: null,
      homeIncome: null,
      mainLogin: false,
      income_method: "2",
      incomes: [
        {
          amount: "",
          freq: 12,
          manual: "2",
          occupation: null,
          level: 1,
          area: 1,
          grossOrNet: "net",
          net: 0,
          gross: 0,
        },
      ],
      finalEmail: null,
      errorMsg: "",
      forgetMsg: "",
      clicked: false,
      tutorialtext: "Hide Video",
      hidetutorial: false,
      loggedUser: null,
      zip_codes: zip_codes,
      state_gross: state_gross,
      occupationGrossIncome: "0",
      value: 1,
      checkPeerParentValue1: false,
      checkPeerParentValue2: false,
      data: [
        {
          id: 1,
          name: "1",
        },
        {
          id: 2,
          name: "2",
        },
        {
          id: 3,
          name: "3",
        },
        {
          id: 4,
          name: "4",
        },
        {
          id: 5,
          name: "5+",
        },
      ],
      dotOptions: [],
      occupationAIText: [],
      occupationAILoad: false,
    };
  },

  methods: {
    // redirectToBiz() {
    //   window.location.href = "https://biz.spendid.io/login";
    // },
    addMember() {
      this.age.push('');
    },
    removeMember(index) {
      this.age.splice(index, 1);
    },
    NumbersOnly(e) {
      if (!/[0-9]/.test(e.key)) e.preventDefault();
    },
    avoidDecimal(value) {
      return value.replace(/\D/g, '');
    },
    checkStatusMode() {
      // default mode is false
      window.localStorage.setItem("mode", false)
      setInterval(() => {
        const getModeStatus = window.localStorage.getItem("mode");
        if (getModeStatus == 'false') {
          document.body.classList.remove("darkmode");
          this.checked = false;
        } else {
          document.body.classList.add("darkmode");
          this.checked = true;
        }
      }, 1)
    },
    changeDwellingSize(value) {
      this.$emit('updateDwelling', {
        value
      });
    },
    changeAreaName(value) {
      this.$emit('updateAreaName', {
        value
      });
    },
    changeRoomMate(value) {
      this.$emit('roomMateCount', {
        value
      });
    },
    clearIncome(index) {
      // Clear occupation and amount
      if (this.incomes[index]) {
        this.incomes[index].occupation = null;
        this.incomes[index].amount = null;
      }

      // Clear input field
      const ref = this.$refs.input_amount;
      if (Array.isArray(ref)) {
        if (ref[index] && typeof ref[index].clear === 'function') {
          ref[index].clear();
        }
      } else {
        if (ref && typeof ref.clear === 'function') {
          ref.clear();
        }
      }

      // Clear AI text
      this.occupationAIText = [];

      // Remove disable classes on area/state/nation
      const refArray = this.$refs[`area-${index}`]; // assuming key == index
      const el = Array.isArray(refArray) ? refArray[0] : refArray;

      if (el && el.classList) {
        el.classList.remove('area-disable', 'state-disable', 'nation-disable');

        // These boolean checks should exist or be computed before
        if (!this.hasArea) el.classList.add('area-disable');
        if (!this.hasState) el.classList.add('state-disable');
        if (!this.hasNational) el.classList.add('nation-disable');
      }
    },
    handleClick(size) {
      console.log('default click ', this.sendDefaultValue);
      this.roommatesCount = 0;
      this.selectedDwellingSize = size;
      const numeric = parseFloat(this.selectedZip && this.selectedZip[size]) || 0;
      const value = this.rentOrOwn === 'own' ? numeric * 1.33 : numeric;

      this.setMortgage(value);
      this.changeDwellingSize(size);
      this.baseRent = value;

      this.updateSharedRent();
    },

    //  handleClick(size) {
    //   console.log('default click ', this.sendDefaultValue);
    //   this.roommatesCount = 0;
    //   this.selectedDwellingSize = size;

    //   const value =
    //     this.rentOrOwn === 'own'
    //       ? this.selectedZip[size] * 1.33
    //       : this.selectedZip[size];

    //   this.setMortgage(value);
    //   this.changeDwellingSize(size);

    //   const selectedValue =
    //     this.selectedZip && this.selectedZip[size]
    //       ? parseFloat(this.selectedZip[size])
    //       : 0;

    //   this.baseRent = selectedValue;
    //   this.updateSharedRent();
    // },

    setRoommates(count) {
      this.roommatesCount = count;
      this.updateSharedRent();
      this.changeRoomMate(count);
    },

    updateSharedRent() {
      if (this.baseRent > 0 && this.selectedZip) {
        // divide rent by (roommates + 1) → include user in total share
        this.monthlyRent = parseFloat(
          (this.baseRent / (this.roommatesCount + 1)).toFixed(2)
        );
      } else {
        this.baseRent = this.monthlyRent
        this.monthlyRent = parseFloat(
          (this.baseRent / (this.roommatesCount + 1)).toFixed(2)
        );
      }
    },
    onKeydown(event) {
      if (event.key === 'Tab' && this.suggestions.length > 0) {
        this.selectZip(this.suggestions[0])
      }
    },
    usdValue(val) {
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
      });
      return formatter.format(parseInt(val) || 0);
    },
    setMortgage(value) {
      const _this = this
      this.monthlyRent = parseFloat(value).toFixed();
      _this.$refs[`field_6`].focus();
      setTimeout(() => {
        _this.$refs[`field_10`].focus();
      }, 200);
    },
    onInput(value) {
      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(() => {
        localStorage.setItem('searchZipValue', value);
        this.showSuggestions = true
        this.fetchZips();
      }, 300); // debounce delay
    },
    async fetchZips() {
      if (this.search.length < 2) {
        this.suggestions = [];
        return;
      }

      try {
        const res = await this.$http.get(`https://admin.spendid.io/api/serach-area-data?search=${encodeURIComponent(this.search)}`);

        this.suggestions = res.data.plans; // Assuming your API returns an array of { id, zip, city, state }
      } catch (err) {
        console.error('Failed to fetch zips:', err);
        this.suggestions = [];
      }
    },
    selectZip(zip) {
      localStorage.setItem("areaName", zip.area_name);
      this.changeAreaName(zip.area_name);
      this.selectedZip = zip;
      this.temp = zip
      //this.isZipSelected = parseInt(this.search,10).toString().length === 5;
      this.isZipSelected = +this.search % 1 === 0 ? true : false;
      this.search = '';
      this.zip = zip.zip_code;
      this.showSuggestions = false;
      this.$refs['field_3'].focus();
    },
    hideSuggestions() {
      setTimeout(() => {
        this.showSuggestions = false;
      }, 200); // Delay to allow mousedown event
    },
    chooseOccupationAI(key) {
      console.log(key);

      this.$bvModal.hide('career-fit-2')
      this.incomes[this.activeCareer].occupation = key;
      this.levelChange(
        this.activeCareer,
        this.incomes[this.activeCareer].level,
        this.incomes[this.activeCareer].occupation,
        true,
        this.incomes[this.activeCareer].area
      )
    },
    onOccupations(data) {
      // this.occupations = this.occupations.filter((item) => data.find((i) => i.id.toLowerCase() == item.id.toLowerCase()));

    },
    saveLoan(data) {
      this.studentLoan = data.estimatedPayment;
      this.loanComponentView = false;
      this.$bvModal.hide('student-loan-modal2');
    },
    async fillOccupationText(occupation) {
      const existingOccupation = this.incomes
        .filter((item) => item.manual === "1" && item.occupation)
        .map((item) => item.occupation);
      existingOccupation.push(occupation);
      const formData = new FormData();
      formData.append("req", existingOccupation);
      this.occupationAILoad = true;
      this.occupationAIText = [];
      const result = await this.$http.post(
        "https://admin.spendid.io/api/get-occupation-data",
        { req: existingOccupation }
      );
      // const jsonArray = JSON.parse(jsonString);
      this.occupationAILoad = false;
      this.occupationAIText = result.data.result;
    },
    async introStartFromInterview() {
      const _this = this;
      _this.current_step = 1;
      setTimeout(() => {
        let steps = [
          {
            element: document.querySelector('.mystep-1-card'),
            intro: `Click one of the options to begin`,
          },
        ];

        const intro = introJs();

        intro.setOptions({
          skipLabel: 'Dismiss',
          steps: steps,
          nextLabel: 'Next',
          doneLabel: 'Next',
          exitOnOverlayClick: false,
          disableInteraction: true,
          scrollToElement: false,
          positionPrecedence: ["bottom", "top", "right", "left"],
        });

        intro.onexit(() => {
          _this.handleOutsideClick();
        });

        intro.oncomplete(() => {
          _this.current_step = 2;
          _this.clicked = true;
          _this.tutorialtext = "Watch Onboard Tutorial";
          _this.introStartFromStep2();
        });

        intro.start();
      }, 1500);
    },

    async introStartFromStep2() {
      const _this = this;
      _this.current_step = 2;
      setTimeout(() => {
        let steps = [
          {
            element: document.querySelector('.mystep-2-card'),
            intro: `Set Location.`,
          },
        ];

        const intro = introJs();

        intro.setOptions({
          skipLabel: 'Dismiss',
          steps: steps,
          nextLabel: 'Next',
          doneLabel: 'Next',
          disableInteraction: true,
          exitOnOverlayClick: false,
          scrollToElement: false,
          showButtons: true,
          positionPrecedence: ["bottom", "top", "right", "left"],
        });

        intro.onafterchange(() => {
          const tooltip = document.querySelector('.introjs-tooltip');
          if (!tooltip.querySelector('.custom-back-btn')) {
            const backBtn = document.createElement('a');
            backBtn.className = 'introjs-button custom-back-btn';
            backBtn.innerText = 'Back';
            backBtn.style.marginRight = '8px';
            backBtn.style.borderRadius = '8px';
            backBtn.onclick = () => {
              _this.introStartFromInterview();
              intro.exit();
            };
            const buttonGroup = tooltip.querySelector('.introjs-tooltipbuttons');
            buttonGroup.insertBefore(backBtn, buttonGroup.firstChild);
          }
        });

        intro.onexit(() => {
          _this.handleOutsideClick();
        });

        intro.oncomplete(() => {
          _this.current_step = 3;
          _this.clicked = true;
          _this.tutorialtext = "Watch Onboard Tutorial";
          _this.introStartFromStep3();
        });

        intro.start();
      }, 1000);
    },

    async introStartFromStep3() {
      const _this = this;
      _this.current_step = 3;
      setTimeout(() => {
        let steps = [
          {
            element: document.querySelector('.mystep-3-card'),
            intro: `Enter Ages`,
            tooltipPosition: 'right',
          },
        ];

        const intro = introJs();

        intro.setOptions({
          skipLabel: 'Dismiss',
          steps: steps,
          nextLabel: 'Next',
          doneLabel: 'Next',
          disableInteraction: true,
          exitOnOverlayClick: false,
          scrollToElement: false,
          showButtons: true,
          positionPrecedence: ["bottom", "top", "right", "left"],
        });

        intro.onafterchange(() => {
          const tooltip = document.querySelector('.introjs-tooltip');
          if (!tooltip.querySelector('.custom-back-btn')) {
            const backBtn = document.createElement('a');
            backBtn.className = 'introjs-button custom-back-btn';
            backBtn.innerText = 'Back';
            backBtn.style.marginRight = '8px';
            backBtn.style.borderRadius = '8px';
            backBtn.onclick = () => {
              _this.introStartFromStep2();
              intro.exit();
            };
            const buttonGroup = tooltip.querySelector('.introjs-tooltipbuttons');
            buttonGroup.insertBefore(backBtn, buttonGroup.firstChild);
          }
        });

        intro.onexit(() => {
          _this.setData(_this.oldData);
          _this.activeTab = ['Your Result'];
          _this.inDemo = false;
        });

        intro.oncomplete(() => {
          _this.current_step = 4;
          _this.clicked = true;
          _this.tutorialtext = "Watch Onboard Tutorial";
          _this.introStartFromStep5();
        });

        intro.start();
      }, 1000);
    },

    async introStartFromStep5() {
      const _this = this;
      _this.current_step = 5;
      setTimeout(() => {
        let steps = [
          {
            element: document.querySelector('.mystep-5-card'),
            intro: `Choose Housing Type and Set Major Expense Amounts`,
            tooltipPosition: 'right',
          },
        ];

        const intro = introJs();

        intro.setOptions({
          skipLabel: 'Dismiss',
          steps: steps,
          nextLabel: 'Next',
          doneLabel: 'Next',
          disableInteraction: true,
          exitOnOverlayClick: false,
          scrollToElement: false,
          showButtons: true,
          positionPrecedence: ["bottom", "top", "right", "left"],
        });

        intro.onafterchange(() => {
          const tooltip = document.querySelector('.introjs-tooltip');
          if (!tooltip.querySelector('.custom-back-btn')) {
            const backBtn = document.createElement('a');
            backBtn.className = 'introjs-button custom-back-btn';
            backBtn.innerText = 'Back';
            backBtn.style.marginRight = '8px';
            backBtn.style.borderRadius = '8px';
            backBtn.onclick = () => {
              _this.introStartFromStep3();
              intro.exit();
            };
            const buttonGroup = tooltip.querySelector('.introjs-tooltipbuttons');
            buttonGroup.insertBefore(backBtn, buttonGroup.firstChild);
          }
        });

        intro.onexit(() => {
          _this.setData(_this.oldData);
          _this.activeTab = ['Your Result'];
          _this.inDemo = false;
        });

        intro.oncomplete(() => {
          _this.current_step = 6;
          _this.clicked = true;
          _this.tutorialtext = "Watch Onboard Tutorial";
          _this.introStartFromStep6();
        });

        intro.start();
      }, 1000);
    },

    async introStartFromStep6() {
      const _this = this;
      _this.current_step = 6;
      setTimeout(() => {
        let steps = [
          {
            element: document.querySelector('.mystep-6-card'),
            intro: `Select Mortgage or Rent and Set Amount`,
            tooltipPosition: 'right',
          },
        ];

        const intro = introJs();

        intro.setOptions({
          skipLabel: 'Dismiss',
          steps: steps,
          nextLabel: 'Next',
          doneLabel: 'Next',
          disableInteraction: true,
          exitOnOverlayClick: false,
          scrollToElement: false,
          showButtons: true,
          positionPrecedence: ["bottom", "top", "right", "left"],
        });

        intro.onafterchange(() => {
          const tooltip = document.querySelector('.introjs-tooltip');
          if (!tooltip.querySelector('.custom-back-btn')) {
            const backBtn = document.createElement('a');
            backBtn.className = 'introjs-button custom-back-btn';
            backBtn.innerText = 'Back';
            backBtn.style.marginRight = '8px';
            backBtn.style.borderRadius = '8px';
            backBtn.onclick = () => {
              _this.introStartFromStep5();
              intro.exit();
            };
            const buttonGroup = tooltip.querySelector('.introjs-tooltipbuttons');
            buttonGroup.insertBefore(backBtn, buttonGroup.firstChild);
          }
        });

        intro.onexit(() => {
          _this.setData(_this.oldData);
          _this.activeTab = ['Your Result'];
          _this.inDemo = false;
        });

        intro.oncomplete(() => {
          _this.current_step = 7;
          _this.clicked = true;
          _this.tutorialtext = "Watch Onboard Tutorial";
          _this.introStartFromStep7();
        });

        intro.start();
      }, 1000);
    },

    async introStartFromStep7() {
      const _this = this;
      _this.current_step = 7;
      setTimeout(() => {
        let steps = [
          {
            element: document.querySelector('.mystep-7-card'),
            intro: `Enter Total Monthly Vehicle Payments`,
            tooltipPosition: 'right',
          },
        ];

        const intro = introJs();

        intro.setOptions({
          skipLabel: 'Dismiss',
          steps: steps,
          nextLabel: 'Next',
          doneLabel: 'Next',
          disableInteraction: true,
          exitOnOverlayClick: false,
          scrollToElement: false,
          showButtons: true,
          positionPrecedence: ["bottom", "top", "right", "left"],
        });

        intro.onafterchange(() => {
          const tooltip = document.querySelector('.introjs-tooltip');
          if (!tooltip.querySelector('.custom-back-btn')) {
            const backBtn = document.createElement('a');
            backBtn.className = 'introjs-button custom-back-btn';
            backBtn.innerText = 'Back';
            backBtn.style.marginRight = '8px';
            backBtn.style.borderRadius = '8px';
            backBtn.onclick = () => {
              _this.introStartFromStep6();
              intro.exit();
            };
            const buttonGroup = tooltip.querySelector('.introjs-tooltipbuttons');
            buttonGroup.insertBefore(backBtn, buttonGroup.firstChild);
          }
        });

        intro.onexit(() => {
          _this.setData(_this.oldData);
          _this.activeTab = ['Your Result'];
          _this.inDemo = false;
        });

        intro.oncomplete(() => {
          _this.current_step = 8;
          _this.clicked = true;
          _this.tutorialtext = "Watch Onboard Tutorial";
          _this.introStartFromStep8();
        });

        intro.start();
      }, 1000);
    },

    async introStartFromStep8() {
      const _this = this;
      _this.current_step = 8;
      setTimeout(() => {
        let steps = [
          {
            element: document.querySelector('.mystep-8-card'),
            intro: `Enter Health Insurance Premium (if applicable)`,
            tooltipPosition: 'right',
          },
        ];

        const intro = introJs();

        intro.setOptions({
          skipLabel: 'Dismiss',
          steps: steps,
          nextLabel: 'Next',
          doneLabel: 'Next',
          disableInteraction: true,
          exitOnOverlayClick: false,
          scrollToElement: false,
          showButtons: true,
          positionPrecedence: ["bottom", "top", "right", "left"],
        });

        intro.onafterchange(() => {
          const tooltip = document.querySelector('.introjs-tooltip');
          if (!tooltip.querySelector('.custom-back-btn')) {
            const backBtn = document.createElement('a');
            backBtn.className = 'introjs-button custom-back-btn';
            backBtn.innerText = 'Back';
            backBtn.style.marginRight = '8px';
            backBtn.style.borderRadius = '8px';
            backBtn.onclick = () => {
              _this.introStartFromStep7();
              intro.exit();
            };
            const buttonGroup = tooltip.querySelector('.introjs-tooltipbuttons');
            buttonGroup.insertBefore(backBtn, buttonGroup.firstChild);
          }
        });

        intro.onexit(() => {
          _this.setData(_this.oldData);
          _this.activeTab = ['Your Result'];
          _this.inDemo = false;
        });

        intro.oncomplete(() => {
          _this.current_step = 9;
          _this.clicked = true;
          _this.tutorialtext = "Watch Onboard Tutorial";
          _this.introStartFromStep9();
        });

        intro.start();
      }, 1000);
    },

    async introStartFromStep9() {
      const _this = this;
      _this.current_step = 9;
      _this.$parent.stepEnable = true;
      setTimeout(() => {
        let steps = [
          {
            element: document.querySelector('.mystep-9-card'),
            intro: `Select Any Other Monthly Debt Payments`,
            tooltipPosition: 'right',
          },
        ];

        const intro = introJs();

        intro.setOptions({
          skipLabel: 'Dismiss',
          steps: steps,
          nextLabel: 'Next',
          doneLabel: 'Next',
          disableInteraction: true,
          exitOnOverlayClick: false,
          scrollToElement: false,
          showButtons: true,
          positionPrecedence: ["bottom", "top", "right", "left"],
        });

        intro.onafterchange(() => {
          const tooltip = document.querySelector('.introjs-tooltip');
          if (!tooltip.querySelector('.custom-back-btn')) {
            const backBtn = document.createElement('a');
            backBtn.className = 'introjs-button custom-back-btn';
            backBtn.innerText = 'Back';
            backBtn.style.marginRight = '8px';
            backBtn.style.borderRadius = '8px';
            backBtn.onclick = () => {
              _this.introStartFromStep8();
              intro.exit();
            };
            const buttonGroup = tooltip.querySelector('.introjs-tooltipbuttons');
            buttonGroup.insertBefore(backBtn, buttonGroup.firstChild);
          }
        });

        intro.onexit(() => {
          _this.setData(_this.oldData);
          _this.activeTab = ['Your Result'];
          _this.inDemo = false;
        });

        intro.oncomplete(() => {
          // _this.current_step = 10;
          _this.clicked = true;
          _this.tutorialtext = "Watch Onboard Tutorial";
          _this.$parent.stepEnable = false
          _this.$parent.introStartFromStep5();
        });

        intro.start();
      }, 1000);
    },

    // async introStartFromStep10() {
    //   const _this = this;
    //   _this.current_step = 11;
    //   // _this.$parent.stepEnable = true;
    //   setTimeout(() => {
    //     let steps = [
    //       {
    //         element: document.querySelector('.mystep-10-card'),
    //         intro: `This is the Main Dashboard. Explore Results, Edit Any Assumptions and Create Endless Simulations.`,
    //       },
    //     ];

    //     const intro = introJs();

    //     intro.setOptions({
    //       skipLabel: 'Dismiss',
    //       steps: steps,
    //       nextLabel: 'Next',
    //       doneLabel: 'Next',
    //       disableInteraction: true,
    //       exitOnOverlayClick: false,
    //       scrollToElement: false,
    //       showButtons: true,
    //       positionPrecedence: ["bottom", "top", "right", "left"],
    //     });

    //     intro.onafterchange(() => {
    //       const tooltip = document.querySelector('.introjs-tooltip');
    //       if (!tooltip.querySelector('.custom-back-btn')) {
    //         const backBtn = document.createElement('a');
    //         backBtn.className = 'introjs-button custom-back-btn';
    //         backBtn.innerText = 'Back';
    //         backBtn.style.marginRight = '8px';
    //         backBtn.style.borderRadius = '8px';
    //         backBtn.onclick = () => {
    //           _this.current_step = 9;
    //           _this.$parent.stepEnable = true;
    //           _this.introStartFromStep9();
    //           intro.exit();
    //         };
    //         const buttonGroup = tooltip.querySelector('.introjs-tooltipbuttons');
    //         buttonGroup.insertBefore(backBtn, buttonGroup.firstChild);
    //       }
    //     });

    //     intro.onexit(() => {
    //       _this.setData(_this.oldData);
    //       _this.activeTab = ['Your Result'];
    //       _this.inDemo = false;
    //     });

    //     intro.oncomplete(() => {
    //       _this.current_step = 11;
    //       _this.clicked = true;
    //       _this.tutorialtext = "Watch Onboard Tutorial";
    //       _this.$parent.stepEnable = false
    //       _this.$parent.introStartFromStep5();
    //     });

    //     intro.start();
    //   }, 1000);
    // },

    startOver() {
      this.current_step = 1;
      this.healthInsurance = "no";
      this.numberOfPeople = "";
      this.household_members = this.age.length;
      (this.monthlyRent = 0), (this.totalMonthly = 0), (this.month_debs = "");
      this.age = [""];
      this.zip = "";
      this.rentOrOwn = "";
      this.max_step = 1;
      this.creditDebtPayment = null;
      this.studentLoan = null;
      this.alimonyPayments = null;
      this.homeEquityPayment = null;
      this.childSupportPayments = null;
      this.estimatedTaxPayments = null;
      this.otherDebtPayments = null;
      this.incomes = [
        {
          amount: "",
          freq: 12,
          manual: "2",
          occupation: null,
          level: 1,
          area: 1,
          grossOrNet: "net",
          net: 0,
          gross: 0,
        },
      ];
    },
    unmaskMoneyValue(val) {
      return val.replace("$", "").replace(",", "");
    },
    changeMode(event) {
      this.$parent.changeMode(event);
    },
    onCheckBoxChange() {
      this.$parent.changeMode(this.checked);
    },
    incomeChange(key, manual) {
      const inc = _.cloneDeep(this.incomes);

      inc[key] = {
        amount: "",
        freq: 12,
        manual,
        occupation: null,
        level: 1,
        area: 1,
        grossOrNet: manual == "2" ? "net" : "gross",
        gross: 0,
        net: 0,
      };

      this.incomes = inc;
    },
    // async levelChange(key, level, occupation, isOccupationChange = false,area) {
    //   if (occupation && level) {
    //     const selectedOccupation = this.occupations.find(
    //       (item) => item.id == occupation
    //     );
    //     let occ = null;
    //     const currentYear = new Date().getFullYear();
    //     const request = {
    //     "request_id": "test",
    //     "location": this.zip,
    //     "occupation": occupation,
    //     "apartment_room_count": "4",
    //     "householdSize": this.age.length,
    //     "birthYears": this.age.map((item) => currentYear - item).join(","),
    //   }
    //     const headers = {
    //       'x-api-key': 'zeN7kb7YRU9N0DGv2M1Yr3wLMnZntYTX3hHl1yVp'
    //     }
    //     const refAmt = this.$refs[`amt-${key}`];
    //     const ela = Array.isArray(refAmt) ? refAmt[0] : refAmt;
    //     if (ela && ela.classList) {
    //       ela.classList.add('amt-loader');
    //     }
    //     const result = await this.$http.post(
    //     "https://api.spendid.io/v2.0/area-costs-analysis",
    //     request, 
    //     {
    //         headers,
    //       }
    //     );
    //     if (ela && ela.classList) {
    //       ela.classList.remove('amt-loader');
    //     }
    //     const data = result.data;

    //     let areaType = '';
    //     const hasArea = data['oew_by_location_area'] && Object.keys(data['oew_by_location_area']).length > 0;
    //     const hasState = data['oew_by_location_state'] && Object.keys(data['oew_by_location_state']).length > 0;
    //     const hasNational = data['oew_by_location_national'] && Object.keys(data['oew_by_location_national']).length > 0;

    //     // Step 1: Determine areaType based on selected area and data availability
    //     if (area === 1 && hasArea) {
    //       areaType = 'oew_by_location_area';
    //     } else if (area === 2 && hasState) {
    //       areaType = 'oew_by_location_state';
    //     } else if (area === 3 && hasNational) {
    //       areaType = 'oew_by_location_national';
    //     } else if (hasArea) {
    //       areaType = 'oew_by_location_area';
    //     } else if (hasState) {
    //       areaType = 'oew_by_location_state';
    //     } else if (hasNational) {
    //       areaType = 'oew_by_location_national';
    //     } else {
    //       areaType = 'oew_by_location_area'; // default fallback if none have data
    //     }
    //     console.log(areaType, 'areaType');

    //     // Step 2: Determine numeric area value
    //     let activeAreaType = 3;
    //     if (areaType === 'oew_by_location_area') activeAreaType = 1;
    //     else if (areaType === 'oew_by_location_state') activeAreaType = 2;


    //     // this.incomes[key].area = activeAreaType;

    //     // Step 3: Add/remove relevant classes based on availability
    //     const refArray = this.$refs[`area-${key}`];
    //     const el = Array.isArray(refArray) ? refArray[0] : refArray;

    //     if (el && el.classList) {
    //       el.classList.remove('area-disable', 'state-disable', 'nation-disable');

    //       if (!hasArea) el.classList.add('area-disable');
    //       if (!hasState) el.classList.add('state-disable');
    //       if (!hasNational) el.classList.add('nation-disable');
    //     }



    //     if (level == 1) {
    //       occ = `${data[areaType]['Low End'].toFixed(0)}`;
    //     } else if (level == 2) {
    //       occ = `${data[areaType]['25th Percentile'].toFixed(0)}`;
    //     } else if (level == 3) {
    //       occ = `${data[areaType]['Median'].toFixed(0)}`;
    //     } else if (level == 4) {
    //       occ = `${data[areaType]['75th Percentile'].toFixed(0)}`;
    //     } else if (level == 5) {
    //       occ = `${data[areaType]['High End'].toFixed(0)}`;
    //     }
    //     const inc = _.cloneDeep(this.incomes);
    //     // inc[key] = {
    //     //   amount: occ,
    //     //   freq: 1,
    //     //   manual: "1",
    //     //   occupation,
    //     //   grossOrNet: "gross",
    //     //   level: level,
    //     //   area: activeAreaType,
    //     //   gross: parseInt(occ / 12),
    //     //   net: 0,
    //     // };

    //     const url = "https://api.spendid.io/v1.0/calculators/net-income?gross=";
    //     const URI = `${url}${occ}&zip=${this.zip}`;
    //     const config = {
    //       headers: { "x-api-key": "HTDzMgEntXaBYVFZ6SSth2iosFRjVe7F8QtM4HBr" },
    //     };
    //     const net = await this.$http.get(URI, config);
    //     inc[key] = {
    //       amount: occ,
    //       freq: 1,
    //       manual: "1",
    //       area:activeAreaType,
    //       occupation,
    //       level: level,
    //       grossOrNet: "gross",
    //       gross: parseInt(occ / 12),
    //       net: net.data.net_annual_income / 12,
    //     };

    //     this.incomes = inc;
    //     const _this = this;
    //     setTimeout(() => {
    //       _this.$refs[`input_amount`][key].onBlur();
    //     }, 200);
    //   }
    //   if (isOccupationChange) {
    //     if (occupation) {
    //       this.fillOccupationText(occupation);
    //     } else {
    //       this.occupationAIText = [];
    //     }
    //   }
    // },
    async levelChange(key, level, occupation, isOccupationChange = false, area) {
      if (occupation && level) {
        const selectedOccupation = this.occupations.find(item => item.id == occupation);
        let occ = null;
        const currentYear = new Date().getFullYear();
        const request = {
          request_id: "test",
          location: this.selectedZip
            ? (this.isZipSelected ? this.selectedZip.zip_code : this.selectedZip.area_name || "")
            : "",
          occupation,
          apartment_room_count: "4",
          householdSize: this.age.length,
          birthYears: this.age.map(item => currentYear - item).join(","),
        };
        const headers = {
          'x-api-key': 'zeN7kb7YRU9N0DGv2M1Yr3wLMnZntYTX3hHl1yVp'
        };

        const refAmt = this.$refs[`amt-${key}`];
        const ela = Array.isArray(refAmt) ? refAmt[0] : refAmt;
        if (ela && ela.classList) {
          ela.classList.add('amt-loader');
        }

        const result = await this.$http.post(
          "https://api.spendid.io/v2.0/area-costs-analysis",
          request,
          { headers }
        );

        if (ela && ela.classList) {
          ela.classList.remove('amt-loader');
        }

        const data = result.data;

        // Validate function without optional chaining
        function isValidAreaData(data) {
          const keysToCheck = ['Low End', '25th Percentile', 'Median', '75th Percentile', 'High End'];
          return keysToCheck.some(function (key) {
            const val = data && data[key];
            return val !== null && val !== undefined && val !== "*" && !isNaN(val);
          });
        }

        function isValidValue(val) {
          return val !== null && val !== undefined && val !== "*" && !isNaN(val);
        }
        const hasArea = isValidAreaData(data['oew_by_location_area']);
        const hasState = isValidAreaData(data['oew_by_location_state']);
        const hasNational = isValidAreaData(data['oew_by_location_national']);

        let areaType = '';
        if (area === 1 && hasArea) {
          areaType = 'oew_by_location_area';
        } else if (area === 2 && hasState) {
          areaType = 'oew_by_location_state';
        } else if (area === 3 && hasNational) {
          areaType = 'oew_by_location_national';
        } else if (hasArea) {
          areaType = 'oew_by_location_area';
        } else if (hasState) {
          areaType = 'oew_by_location_state';
        } else if (hasNational) {
          areaType = 'oew_by_location_national';
        } else {
          areaType = 'oew_by_location_area'; // fallback
        }

        console.log(areaType, 'areaType');

        let activeAreaType = 3;
        if (areaType === 'oew_by_location_area') activeAreaType = 1;
        else if (areaType === 'oew_by_location_state') activeAreaType = 2;

        const refArray = this.$refs[`area-${key}`];
        const el = Array.isArray(refArray) ? refArray[0] : refArray;

        if (el && el.classList) {
          el.classList.remove('area-disable', 'state-disable', 'nation-disable');
          if (!hasArea) el.classList.add('area-disable');
          if (!hasState) el.classList.add('state-disable');
          if (!hasNational) el.classList.add('nation-disable');
        }

        const selectedData = data[areaType];
        // ========== NEW: per-level disable logic (per row key) ==========
        const disabledForThisRow = {
          1: !isValidValue(selectedData["Low End"]),
          2: !isValidValue(selectedData["25th Percentile"]),
          3: !isValidValue(selectedData["Median"]),
          4: !isValidValue(selectedData["75th Percentile"]),
          5: !isValidValue(selectedData["High End"]),
        };

        // make sure disabledLevels is reactive and stored by row (key)
        if (!this.disabledLevels) {
          this.disabledLevels = {};
        }

        // Vue 2 reactivity safe update
        if (this.$set) {
          this.$set(this.disabledLevels, key, disabledForThisRow);
        } else {
          this.disabledLevels = {
            ...this.disabledLevels,
            [key]: disabledForThisRow,
          };
        }

        console.log("disabledLevels for row:", key, this.disabledLevels[key]);

        // If clicked level has invalid value, stop here (button should be disabled)
        if (disabledForThisRow[level]) {
          console.warn("Level", level, "is disabled for row", key);
          return;
        }

        if (level == 1) {
          occ = `${selectedData['Low End']}`;
        } else if (level == 2) {
          occ = `${selectedData['25th Percentile']}`;
        } else if (level == 3) {
          occ = `${selectedData['Median']}`;
        } else if (level == 4) {
          occ = `${selectedData['75th Percentile']}`;
        } else if (level == 5) {
          occ = `${selectedData['High End']}`;
        }

        const inc = _.cloneDeep(this.incomes);
        const url = "https://api.spendid.io/v1.0/calculators/net-income?gross=";
        const URI = `${url}${occ}&zip=${this.zip}`;
        const config = {
          headers: { "x-api-key": "HTDzMgEntXaBYVFZ6SSth2iosFRjVe7F8QtM4HBr" },
        };

        const net = await this.$http.get(URI, config);
        inc[key] = {
          amount: occ,
          freq: 1,
          manual: "1",
          area: activeAreaType,
          occupation,
          level: level,
          grossOrNet: "gross",
          gross: parseInt(occ / 12),
          net: net.data.net_annual_income / 12,
        };

        this.incomes = inc;
        const _this = this;
        setTimeout(() => {
          _this.$refs[`input_amount`][key].onBlur();
        }, 200);
      }

      if (isOccupationChange) {
        if (occupation) {
          this.fillOccupationText(occupation);
        } else {
          this.occupationAIText = [];
        }
      }
    },
    async getOccupation() {
      const URI = "https://api.spendid.io/v1.0/occupations";

      const config = {
        headers: { "x-api-key": "HTDzMgEntXaBYVFZ6SSth2iosFRjVe7F8QtM4HBr" },
      };
      const occu = await this.$http.get(URI, config);
      this.occupations = occu.data.occupations;
    },
    checkPeerParent1() {
      this.checkPeerParentValue1 = true;
    },
    checkPeerParent2() {
      this.checkPeerParentValue2 = true;
    },
    checkPeer(param) {
      const URI = "https://api.spendid.io/v1.0/demographics/models/generate";

      let trasformer = transformer_38;
      let demograph = {
        net_annual_income: this.monthly_take_home_net * 12,
        age: parseInt(this.age[0]),
        household_members: parseInt(this.age.length),
        zip: this.zip,
        is_homeowner: this.rentOrOwn === "own",
      };
      const config = {
        headers: { "x-api-key": "HTDzMgEntXaBYVFZ6SSth2iosFRjVe7F8QtM4HBr" },
      };
      this.$http
        .post(
          URI,
          JSON.stringify({
            demographics: demograph,
            transformer: trasformer,
          }),
          config
        )
        .then((res) => {
          const data = res.data;
          if (param === "mortgage_and_rent") {
            this.monthlyRent = null;
            // this.$refs.field_6.$el.value=null;
            this.monthlyRent = (data.model.mortgage_and_rent / 12)
              .toFixed(0)
              .toString();
            setTimeout(() => {
              this.$refs[`field_6`].focus();
            }, 200);
            // this.$refs[`field_6`].focusOut();
          } else if (param === "vehicle_purchase_and_lease") {
            this.totalMonthly = (data.model.vehicle_purchase_and_lease / 12)
              .toFixed(0)
              .toString();
            setTimeout(() => {
              this.$refs[`field_10`].focus();
            }, 200);
          } else if (param === "other_debt_payments") {
            const totalDebt = (data.model.other_debt_payments / 12)
              .toFixed(0)
              .toString();
            var formatter = new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 0,
              minimumFractionDigits: 0,
            });

            this.totalDebt = formatter.format(Math.round(totalDebt));
          }
        });
    },
    avoidDecimal(value) {
      if (/[^0-9]+/.test(value)) return value.replace(/[^0-9]*/g, "");
      else return value;
    },
    // onByPass() {
    //   this.$router.push({ path: "/", query: { report: "true" } });
    //   location.reload();
    //   this.$emit("stepEnable", false);
    //   this.$cookies.set('stepEnable', false);
    // },
    onByPass() {
      this.$cookies.set('stepEnable', false);
      this.$emit("stepEnable", false);
      this.$router.push({ path: "/", query: { report: "true" } });
    },
    skipInterview() {
      this.$emit("stepEnable", false);
      this.$cookies.set('stepEnable', false);
    },
    openForgetPopup() {
      this.$bvModal.show("forget-popup");
    },
    forgetNow() {
      this.forgetMsg = "";
      this.$http
        .post(`${new_api}/send-email-forget-password`, {
          email: this.forget_user_email,
        })
        .then((res) => {
          // eslint-disable-next-line no-console
          console.log(res);
          this.forgetMsg = "Check email for link to Reset Password";
        });
    },
    loginNow() {
      this.errorMsg = "";
      this.$http
        .post(`${new_api}/login`, {
          email: this.user_email,
          password: this.user_password,
        })
        .then((res) => {
          this.$cookies.set("userDetail", res.data, 0);
          window.dispatchEvent(
            new CustomEvent("loginEvent", {
              detail: res.data.data,
            })
          );
          location.reload();
          this.mainLogin = true;
          this.current_step = 1;

          let headers = {
            Authorization: "Bearer " + res.data.data.access_token,
          };
          this.$http
            .get(`${new_api}/get-last-data-By-user`, { headers })
            .then((response) => {
              if (response.data.data.budget) {
                this.allowBypass = true;
              }
            });
          // this.verifyEnable = false
          // this.verifyMsg = '<p class="text-success  text-center">Code sent to entered email.</p>'
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.log(err);
          this.errorMsg = "Invalid email or password*";
        });
    },
    async onSeourceSelect(i, input = true) {
      if (input) {
        this.$refs[`input_amount`][i].focus();
      }
      const self = this;
      // console.log(self.incomes[RegEx.exec(arg2)[1]].freq);
      setTimeout(async () => {
        const value = await this.recalculateNetAsync(
          this.incomes[i].amount * this.incomes[i].freq,
          this.incomes[i].grossOrNet
        );
        if (self.incomes[i].grossOrNet === "gross") {
          self.incomes[i].gross =
            (self.incomes[i].amount * self.incomes[i].freq) / 12;
          self.incomes[i].net = value;
        } else {
          self.incomes[i].net =
            (self.incomes[i].amount * self.incomes[i].freq) / 12;
          self.incomes[i].gross = value;
        }
      }, 500);
    },
    incomeFinalStepBack() {
      if (this.healthInsurance === "yes") {
        this.current_step = 20;
      } else {
        this.current_step = 5;
      }
    },
    removeIncome(counter) {
      this.incomes.splice(counter, 1);
    },
    addIncomeNew() {
      const inc = this.incomes;
      inc.push({
        amount: "",
        freq: 12,
        manual: "2",
        area: 1,
        occupation: null,
        level: 1,
        grossOrNet: "net",
        net: 0,
        gross: 0,
      });
      this.incomes = inc;
    },
    healthBack() {
      if (this.month_debs == "yes") {
        this.current_step = 14;
      } else {
        this.current_step = 8;
      }
    },
    incomeFinalStep() {
      this.current_step = 13;
    },
    enterEvent(type) {
      const _this = this;
      if (!this.$refs[type].disabled) {
        if (this.$refs[type].getAttribute("data-func")) {
          _this[this.$refs[type].getAttribute("data-func")]();
        } else {
          this.current_step = parseInt(
            this.$refs[type].getAttribute("data-step")
          );
        }
      }
    },
    mainSubmit() {
      const data = {
        current_step: this.current_step,
        rentOrOwn: this.rentOrOwn,
        month_debs: this.month_debs,
        moreIncome: this.moreIncome,
        healthInsurance: this.healthInsurance,
        numberOfPeople: this.age.length,
        age: this.age,
        zip: this.zip,
        currentActiveAlphabet: this.currentActiveAlphabet,
        monthlyRent: this.monthlyRent,
        totalMonthly: this.totalMonthly,
        creditDebtPayment: this.creditDebtPayment,
        studentLoan: this.studentLoan,
        alimonyPayments: this.alimonyPayments,
        homeEquityPayment: this.homeEquityPayment,
        childSupportPayments: this.childSupportPayments,
        estimatedTaxPayments: this.estimatedTaxPayments,
        otherDebtPayments: this.otherDebtPayments,
        healthPremiumAmount: this.healthPremiumAmount,
        homeIncomeAmount1: this.homeIncomeAmount1,
        homeIncome: this.homeIncome,
        grossOrNet: this.grossOrNet,
        incomes: this.incomes,
        finalEmail: this.user_email,
        annual_gross_salary_level_val: this.annual_gross_salary_level_val,
        occupations_val: this.occupations_val,
        income_method: this.income_method,
        occupationAIText: this.occupationAIText,
        sendDefaultValue: this.temp
      };
      this.$emit("submitStepForm", data);
    },
    mainSubmit1() {
      const data = {
        current_step: this.current_step,
        rentOrOwn: this.rentOrOwn,
        month_debs: this.month_debs,
        moreIncome: this.moreIncome,
        healthInsurance: this.healthInsurance,
        numberOfPeople: this.numberOfPeople,
        age: this.age,
        zip: this.zip,
        currentActiveAlphabet: this.currentActiveAlphabet,
        monthlyRent: this.monthlyRent ? this.monthlyRent : 0,
        totalMonthly: this.totalMonthly ? this.totalMonthly : 0,
        creditDebtPayment: this.creditDebtPayment,
        studentLoan: this.studentLoan,
        alimonyPayments: this.alimonyPayments,
        homeEquityPayment: this.homeEquityPayment,
        childSupportPayments: this.childSupportPayments,
        estimatedTaxPayments: this.estimatedTaxPayments,
        otherDebtPayments: this.otherDebtPayments,
        healthPremiumAmount: this.healthPremiumAmount,
        homeIncomeAmount1: this.homeIncomeAmount1,
        homeIncome: this.homeIncome,
        grossOrNet: this.grossOrNet,
        incomes: this.incomes,
        finalEmail: this.user_email,
      };
      this.$emit("submitStepForm", data);
    },
    addIncome() {
      const currentIncome = this.incomes;
      currentIncome.push({
        amount: this.homeIncomeAmount1,
        freq: parseInt(this.homeIncome),
      });
      this.incomes = currentIncome;

      if (this.moreIncome === "yes") {
        this.homeIncomeAmount1 = null;
        this.homeIncome = null;
        this.moreIncome = null;
        this.addMoreIncome();
        this.nextLetter(this.currentActiveAlphabet);
        this.current_step = 10;
      } else {
        this.current_step = 13;
      }
    },
    nextLetter(s) {
      this.currentActiveAlphabet = s.replace(
        /([a-zA-Z])[^a-zA-Z]*$/,
        function (a) {
          var c = a.charCodeAt(0);
          switch (c) {
            case 90:
              return "A";
            case 122:
              return "a";
            default:
              return String.fromCharCode(++c);
          }
        }
      );
    },
    studentLoanNext() {
      if (this.rentOrOwn == "own") {
        this.current_step = 17;
      } else {
        this.current_step = 16;
      }
    },
    addMoreIncome() {
      if (this.moreIncome == "yes") {
        this.current_step = 10;
      } else {
        this.current_step = 13;
      }
    },
    healthInsuranceNext() {
      if (this.healthInsurance == "yes") {
        this.current_step = 20;
      } else {
        this.healthPremiumAmount = 0;
        this.current_step = 10;
      }
    },
    anyOtherNext() {
      this.creditDebtPayment = null;
      this.studentLoan = null;
      this.alimonyPayments = null;
      this.homeEquityPayment = null;
      this.childSupportPayments = null;
      this.estimatedTaxPayments = null;
      this.otherDebtPayments = null;
      if (this.month_debs == "yes") {
        this.current_step = 14;
      } else {
        this.mainSubmit();
      }
    },
    async numberValueChange2(arg, arg2) {
      var arg3 = parseFloat(this.unmaskMoneyValue(arg))
      const RegEx = /\[(.*?)\]/;
      var self = this;
      self.incomes[RegEx.exec(arg2)[1]].amount = arg3;
      const value = await this.recalculateNetAsync(
        arg3 * self.incomes[RegEx.exec(arg2)[1]].freq,
        self.incomes[RegEx.exec(arg2)[1]].grossOrNet
      );
      if (self.incomes[RegEx.exec(arg2)[1]].grossOrNet === "gross") {
        self.incomes[RegEx.exec(arg2)[1]].gross =
          (arg3 * self.incomes[RegEx.exec(arg2)[1]].freq) / 12;
        self.incomes[RegEx.exec(arg2)[1]].net = value;
      } else {
        self.incomes[RegEx.exec(arg2)[1]].net =
          (arg3 * self.incomes[RegEx.exec(arg2)[1]].freq) / 12;
        self.incomes[RegEx.exec(arg2)[1]].gross = value;
      }
      // .then(data => {
      //   console.log(data,'value');
      // })
    },
    numberValueChange(arg, arg2) {
      var self = this;
      self[arg2] = arg ? this.unmaskMoneyValue(arg) : arg;
    },
    nextStep() {
      if (this.current_step < 104) {
        this.current_step = ++this.current_step;
      }
    },
    prevStep() {
      if (this.current_step > 2) {
        this.current_step = --this.current_step;
      }
    },
    NumbersOnly(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    tutorialtorage() {
      this.hidetutorial = true;
      localStorage.setItem("hideTutorial", "false");
    },
    async recalculateNetAsync(amount, grossOrNet) {
      if (typeof this.cancelToken != typeof undefined) {
        this.cancelToken.cancel("Operation canceled due to new request.");
      }
      this.cancelToken = axios.CancelToken.source();
      const url =
        grossOrNet === "gross"
          ? "https://api.spendid.io/v1.0/calculators/net-income?gross="
          : "https://api.spendid.io/v1.0/calculators/gross-income?net=";

      const URI = `${url}${amount}&zip=${this.zip}`;
      const config = {
        headers: { "x-api-key": "HTDzMgEntXaBYVFZ6SSth2iosFRjVe7F8QtM4HBr" },
        cancelToken: this.cancelToken.token,
      };
      const net = await this.$http.get(URI, config);
      return (
        (net.data.net_annual_income && net.data.net_annual_income / 12) ||
        (net.data.gross_annual_income && net.data.gross_annual_income / 12)
      );
    },
    async recalculateNet(amount) {
      if (typeof this.cancelToken != typeof undefined) {
        this.cancelToken.cancel("Operation canceled due to new request.");
      }
      this.cancelToken = axios.CancelToken.source();

      const url =
        this.grossOrNet === "gross"
          ? "https://api.spendid.io/v1.0/calculators/net-income?gross="
          : "https://api.spendid.io/v1.0/calculators/gross-income?net=";

      const URI = `${url}${amount * 12}&zip=${this.zip}`;
      const config = {
        headers: { "x-api-key": "HTDzMgEntXaBYVFZ6SSth2iosFRjVe7F8QtM4HBr" },
        cancelToken: this.cancelToken.token,
      };
      const net = await this.$http.get(URI, config);
      this.netAmount =
        (net.data.net_annual_income && net.data.net_annual_income / 12) ||
        (net.data.gross_annual_income && net.data.gross_annual_income / 12);
    },
    getAnnualOptions(index) {
      const base = this.annual_gross_salary_level || [];
      const rowDisabled = (this.disabledLevels && this.disabledLevels[index]) || {};

      return base.map(option => ({
        ...option,
        disabled: !!rowDisabled[option.value],
      }));
    }
  },
  computed: {
    monthly_take_home() {
      return this.monthly_take_home_input_value
        ? parseFloat(this.unmaskMoneyValue(this.monthly_take_home_input_value))
        : null;
    },
    monthly_take_home_net() {
      return this.netAmountInput
        ? parseFloat(this.unmaskMoneyValue(this.netAmountInput))
        : null;
    },
    netAmountInput() {
      const sum = this.incomes.reduce(
        (partialSum, a) => partialSum + parseFloat(a.net || 0),
        0
      );
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
      });

      return formatter.format(Math.round(sum));
    },
    currentActiveStep() {
      if (this.current_step == 2 || this.current_step == 3) {
        return "Your Profile";
      } else if (this.current_step == 4) {
        return "Your Major Expenses";
      } else {
        return "";
      }
    },
    occupationGrossIncomeFormat() {
      const sum = this.occupationGrossIncome;
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
      });
      if (isNaN(Math.round(sum))) {
        return "$0";
      }
      return formatter.format(Math.round(sum));
    },
    firstSession() {
      return localStorage.getItem("firstSession")
        ? localStorage.getItem("firstSession") == "1"
        : false;
    },
    userName() {
      return (
        (this.$cookies.get("userDetail") && this.$cookies.get("userDetail").data
          ? this.$cookies.get("userDetail").data.name
          : null) || this.data
      );
    },
    userId() {
      return (
        (this.$cookies.get("userDetail") && this.$cookies.get("userDetail").data
          ? this.$cookies.get("userDetail").data.id
          : null) || this.data
      );
    },
    returnUser() {
      return (
        (this.$cookies.get("userDetail") &&
          this.$cookies.get("userDetail").data) ||
        this.$cookies.get("userDetail")
      );
    },
    getCookies() {
      return (
        (this.$cookies.get("userDetail") &&
          this.$cookies.get("userDetail").data) ||
        this.$cookies.get("userDetail")
      );
    },
    otherAllDebs() {
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
      });
      const sum = [
        this.creditDebtPayment,
        this.studentLoan,
        this.homeEquityPayment,
        this.alimonyPayments,
        this.childSupportPayments,
        this.estimatedTaxPayments,
        this.otherDebtPayments,
      ]
        .filter(Boolean)
        .reduce((a, b) => parseInt(a) + parseInt(b), 0);

      return formatter.format(sum);
    },
    monthly_take_home_input_value() {
      const sum = this.incomes.reduce(
        (partialSum, a) => partialSum + parseFloat(a.gross || 0),
        0
      );
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
      });

      return formatter.format(Math.round(sum));
    },
    monthly_take_home_input_value_int() {
      const sum = this.incomes.reduce(
        (partialSum, a) =>
          partialSum + parseFloat(a.gross || 0) * parseInt(a.freq || 0),
        0
      );
      // this.recalculateNet(Math.round(sum / 12));
      return Math.round(sum / 12);
    },
    zipCity() {
      const matchingZip = this.zip_codes.find(
        (item) => item["Zip Code"] === this.zip
      );
      return matchingZip ? matchingZip.City : "";
    },
    zipState() {
      const matchingZip = this.zip_codes.find(
        (item) => item["Zip Code"] === this.zip
      );
      if (matchingZip) {
        const matchingState = this.state_gross.find(
          (it) => it.abbreviation === matchingZip.State
        );
        if (matchingState) {
          return matchingState.state;
        }
      }
      return "";
    },
  },
  watch: {
    rentOrOwn(value) {
      const owner = value === 'own';
      this.monthlyRent = owner ? parseFloat(this.monthlyRent * 1.33).toFixed() : parseFloat(this.monthlyRent / 1.33).toFixed()
    },
    housingType(newVal) {
      localStorage.setItem('housingType', newVal);
    },
    occupations_val: {
      handler(val) {
        if (val && this.annual_gross_salary_level_val) {
          const selectedOccupation = this.occupations.find(
            (item) => item.id == val
          );
          if (this.annual_gross_salary_level_val == 1) {
            this.occupationGrossIncome = selectedOccupation.low;
            this.incomes = [
              {
                amount: `${selectedOccupation.low}`,
                freq: 1,
              },
            ];
          } else if (this.annual_gross_salary_level_val == 2) {
            this.occupationGrossIncome = selectedOccupation.median;
            this.incomes = [
              {
                amount: `${selectedOccupation.median}`,
                freq: 1,
              },
            ];
          } else if (this.annual_gross_salary_level_val == 3) {
            this.occupationGrossIncome = selectedOccupation.high;
            this.incomes = [
              {
                amount: `${selectedOccupation.high}`,
                freq: 1,
              },
            ];
          }
        }
      },
      deep: true,
      immediate: true,
    },
    annual_gross_salary_level_val(val) {
      if (this.occupations_val) {
        const selectedOccupation = this.occupations.find(
          (item) => item.id == this.occupations_val
        );
        if (val == 1) {
          this.occupationGrossIncome = selectedOccupation.low;
          this.incomes = [
            {
              amount: `${selectedOccupation.low}`,
              freq: 1,
            },
          ];
        } else if (val == 2) {
          this.occupationGrossIncome = selectedOccupation.median;
          this.incomes = [
            {
              amount: `${selectedOccupation.median}`,
              freq: 1,
            },
          ];
        } else if (val == 3) {
          this.occupationGrossIncome = selectedOccupation.high;
          this.incomes = [
            {
              amount: `${selectedOccupation.high}`,
              freq: 1,
            },
          ];
        }
      }
    },
    grossOrNet() {
      const sum = this.incomes.reduce(
        (partialSum, a) =>
          partialSum + parseFloat(a.amount || 0) * parseInt(a.freq || 0),
        0
      );
      this.recalculateNet(Math.round(sum / 12));
    },
    current_step(value) {
      window.scrollTo(0, 0);
      this.max_step = value > this.max_step ? value : this.max_step;
      if ([2, 3, 6, 7, 14, 20, 13].includes(value)) {
        setTimeout(() => {
          this.$refs[`field_${value}`].focus();
        }, 200);
      }
    },
    byPass: {
      handler(value) {
        this.byPass = value;
      },
      deep: true,
    },
    numberOfPeople(val) {
      if (val) {
        setTimeout(() => {
          this.current_step = 5;
        }, 300);
      }
    },
    // rentOrOwn(val) {
    //   if (val) {
    //     setTimeout(() => {
    //       this.current_step = 6;
    //     }, 300);
    //   }
    // },
    // month_debs(val) {
    //   if (val == "no") {
    //     setTimeout(() => {
    //       this.anyOtherNext();
    //     }, 300);
    //   }
    // },
    healthInsurance(val) {
      if (val) {
        setTimeout(() => {
          this.healthInsuranceNext();
        }, 300);
      }
    },
    homeIncome(val) {
      if (val) {
        this.$refs.takeHome.focus();
      }
    },
    moreIncome(val) {
      if (val) {
        setTimeout(() => {
          this.addIncome();
        }, 300);
      }
    },
  },
  mounted() {
    if (this.$route.query.report == 'true') this.onByPass();
    this.checkStatusMode();
    localStorage.setItem("selectedDwellingSize", "")
    const saved = localStorage.getItem('housingType');
    if (saved) {
      this.housingType = saved;
    } else {
      localStorage.setItem('housingType', this.housingType);
    }
    this.hidetutorial = localStorage.getItem("hideTutorial")
      ? localStorage.getItem("hideTutorial") === "false"
      : false;
    this.getOccupation();
  },
  created() {

  },
};
</script>

<template>
  <div class="step_form_area header-nav w-100 pt-2" :class="{ 'side-visible': !(!returnUser && !mainLogin) }">
    <b-container>
      <div class="navbar-right-side">
        <!-- <div class="mr-2 mr-md-0">
          <button @click="$parent.openSidebar = openSidebar ? false : true" type="button"
            class="toggle-mobile mr-3 mr-md-2"><i class="fa fa-bars"></i></button>
        </div> -->
        <b-row class="align-items-center">
          <b-col cols="4" md="4" lg="4">
              <div class="d-flex align-items-center mr-2 mr-md-0">
                <!-- <button @click="$parent.openSidebar = openSidebar ? false : true" type="button" class="toggle-mobile mr-3 mr-md-2" ><i class="fa fa-bars"></i></button> -->
                <!-- <b-navbar-toggle size="sm" target="nav-collapse" class="mr-2 mr-lg-0">
                    <span> </span>
                    <span> </span>
                    <span> </span>
                  </b-navbar-toggle> -->
                <b-navbar-brand href="#" class="py-0">
                  <!-- <img alt="logo" class="img-fluid" :src="['gradbudget-plan','gradbudget-school-plan'].includes(userType)?'imgs/Prophecy-Logo.png': 'imgs/Prophecy-Logo.png'" /> -->
                  <img alt="logo" class="img-fluid logo-d" :src="['gradbudget-plan', 'gradbudget-school-plan'].includes(userType)
                    ? 'imgs/Spendid-Cloud-Logo-Dark.png'
                    : 'imgs/Spendid-Cloud-Logo-Dark.png'
                    " />
                  <img alt="logo" class="img-fluid logo-w" :src="['gradbudget-plan', 'gradbudget-school-plan'].includes(userType)
                    ? 'imgs/Spendid-Cloud-Logo-Light.png'
                    : 'imgs/Spendid-Cloud-Logo-Light.png'
                    " />
                </b-navbar-brand>
                <!-- <b-navbar-brand
                    href="#"
                    class="navbar-brand-mini py-0 d-inline-block d-sm-none"
                  >
                    <img alt="logo" class="img-fluid" src="imgs/logo-mini.png" />
                  </b-navbar-brand> -->
            </div>
          </b-col>
          <b-col cols="4" md="4" lg="4">
             <div class="text-center" :class="{ 'd-none': current_step == 1 }" id="step1">
              <img src="imgs/header-title.png" alt="image" class="img-fluid"/>
             </div>
          </b-col>
          <b-col cols="4" md="4" lg="4">
             <div class="d-flex align-items-center justify-content-end flex-gap-input">
              <label class="nav-theme-mode ml-2 mr-md-4 mb-0" onClick="bodyClassAdd()">
                <input type="checkbox" class="checkbox-switch darkLightChange" @change="onCheckBoxChange"
                  v-model="checked" />
                <span class="checkbox-switch-label mb-0">
                  <i class="fas fa-sun"></i>
                  <i class="fas fa-moon"></i>
                  <span class="ball"></span>
                </span>
              </label>
              <div v-if="returnUser" class="acount-profile-wrap d-flex align-items-center justify-content-end my-2">
                <a class="profile_icon profile_icon_step" href="https://biz.spendid.io/analytics">
                  <img :src="`https://biz.spendid.io/api/get-image/${userId}?ver=${Math.random()}`" width="50" />
                </a>
                <p class="ml-2 profile_name profile_name_step">{{ userName }}</p>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-container>
    <b-container :class="{ 'd-none': activeTab.includes('How To') }">
      <b-row ref="step-form" class="step-form">
        <b-col class="col-lg-12">
          <div id="app_steps" class="app_steps w-100">
            <form class="w-100">
              <div class="quick-start text-center my-3" :class="{ 'd-none': current_step != 1 }" id="step1">
                <!-- <b-row>
                  <b-col class="col-md-10 offset-md-1 col-lg-8 offset-lg-2">
                    <div class="d-flex justify-space-between flex-gap-input mb-3">
                      <b-button @click="introStartFromInterview"
                        class="quick-start-btn btn-purple btn-md btn-radius btn-77" type="button">
                        Quick Start Guide
                      </b-button>
                      <b-button href="https://app.supademo.com/demo/cmar0cv7f32grho3rcf08lpm6"
                        class="walkthrough-btn btn-purple btn-md btn-radius btn-77">
                        Detailed Walkthrough
                      </b-button>
                    </div>
                  </b-col>
                </b-row> -->
                <b-row>
                  <b-col md="12">
                    <b-row>
                      <b-col class="col-md-10 offset-md-1 col-lg-8 offset-lg-2">
                        <div class="create-profile welcome-user">
                          <div class="welcome-illustrations mb-2 text-center">
                            <img alt="books" src="imgs/collage-people.png" class="img-fluid " />
                          </div>
                          <div class="welcome-card text-center">
                            <div class="welcome-body p-2">
                              <img src="imgs/Spendid-Cloud-Logo-Dark.png" style="max-height:110px;" class="logo-d"
                                alt="logo" />
                              <img src="imgs/Spendid-Cloud-Logo-Light.png" style="max-height:110px;" class="logo-w"
                                alt="logo" />
                              <!-- <img style="max-height:80px;" src="imgs/logo-w.png" class="logo-w" alt="logo" /> -->
                              <!-- <img style="max-height:80px;" src="imgs/logo-d.png" class="logo-d" alt="logo" />
                              <img style="max-height:80px;" src="imgs/logo-w.png" class="logo-w" alt="logo" /> -->
                              <!-- <h2 class="welcome-title">Welcome!</h2> -->
                              <!-- <p class="welcome-info mb-0">
                                Click
                                <strong class="theme-color1">Start Interview</strong>
                                and answer a few simple prompts to create a
                                <strong>Peer Profile</strong> and a starting
                                point budget in minutes.
                              </p> -->
                            </div>
                            <!-- <div class="welcome-footer p-3">
                              <p class="skip-interview mb-0">
                                Plan smarter. Spend wiser. <br> Succeed sooner.
                              </p>
                            </div> -->
                            <div class="mystep-1-card">
                              <div class="welcome-footer">
                                <h4 class="create-profile-title purple-title mb-3 mb-lg-4">
                                  $ee What's Next. Plan What's Possible.
                                </h4>
                                <!-- <h4 class="create-profile-title mb-3">
                                  Financial Clarity For the Road Ahead
                                </h4> -->
                                <div class="create-profile-action">
                                  <!-- <b-button
                                  class="btn-green m-1"
                                  @click="activeTab = 'How To'"
                                  >Instructions</b-button
                                > -->
                                  <b-button class="btn-green btn-xl m-1" @click="
                                    (current_step = 2),
                                    (clicked = clicked = true),
                                    (tutorialtext = clicked
                                      ? 'Watch Onboard Tutorial'
                                      : 'Hide Video')
                                    ">
                                    <!-- Get Started -->
                                    Create New Scenario
                                  </b-button>


                                  <!-- <b-button @click="redirectToBiz">
                                  back
                                </b-button> -->
                                </div>

                              </div>
                              <!-- <div class="welcome-footer px-2">
                              <p class="skip-interview">Skip Interview and Go Directly to Dashboard</p>
                              <b-button @click="skipInterview" type="button" class="btn-green">Skip Interview
                              </b-button>
                            </div> -->
                              <!-- <div v-if="allowBypass" class="time_duration"> -->
                              <div class="time_duration">
                                <div class="instruction-tooltip">
                                  <b-button @click="onByPass" type="button" class="btn-green">Resume from saved report
                                  </b-button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </div>
            </form>
          </div>
        </b-col>
      </b-row>
      <b-row ref="step-form">
        <b-col>
          <div class="form_block_area w-100 mb-5 mt-3 pb-2 pb-lg-0 my-lg-4" :class="{ 'd-none': current_step == 1 }">
            <!-- question start -->
            <div id="app_steps" class="w-100">
              <form class="w-100">
                <b-row>
                  <b-col class="col-lg-12">
                    <div class="steps-card">
                      <div class="steps-header">
                        <div class="progress_data w-100">
                          <ul>
                            <li :class="{
                              active: current_step == 2,
                              max_active: this.max_step >= 2,
                            }">
                              <a href="#" @click="current_step = 2">1</a>
                            </li>
                            <li :class="{
                              active: current_step == 3,
                              max_active: this.max_step >= 3,
                            }">
                              <a href="#" @click="current_step = 3">2</a>
                            </li>
                            <li :class="{
                              active: current_step == 4,
                              max_active: this.max_step >= 4,
                            }">
                              <a href="#" @click="current_step = 4">3</a>
                            </li>
                            <li :class="{
                              active: current_step == 5,
                              max_active: this.max_step >= 5,
                            }">
                              <a href="#" @click="current_step = 5">4</a>
                            </li>
                            <li :class="{
                              active: current_step == 6,
                              max_active: this.max_step >= 6,
                            }">
                              <a href="#" @click="current_step = 6">5</a>
                            </li>
                            <li :class="{
                              active: current_step == 7,
                              max_active: this.max_step >= 7,
                            }">
                              <a href="#" @click="current_step = 7">6</a>
                            </li>
                            <li :class="{
                              active: current_step == 8,
                              max_active: this.max_step >= 8,
                            }">
                              <a href="#" @click="current_step = 8">7</a>
                            </li>
                            <li :class="{
                              active: current_step == 9,
                              max_active: this.max_step >= 9,
                            }">
                              <a href="#" @click="current_step = 9">8</a>
                            </li>
                            <!-- <li
                                  :class="{
                                    active: current_step == 5,
                                    max_active: this.max_step >= 5
                                  }"
                                >
                                  <a href="#" @click="current_step = 5"
                                    ><div><img src="home-ico.png" /></div>
                                    <span>Home Type</span></a
                                  >
                                </li>
                                <li
                                  :class="{
                                    active: current_step == 6,
                                    max_active: this.max_step >= 6
                                  }"
                                >
                                  <a href="#" @click="current_step = 6"
                                    ><div><img src="income-ico.png" /></div>
                                    <span>Income $</span></a
                                  >
                                </li>
                                <li
                                  :class="{
                                    active: current_step == 8 || current_step == 14,
                                    max_active: this.max_step >= 8 || this.max_step == 14
                                  }"
                                >
                                  <a href="#" @click="current_step = 8"
                                    ><div><img src="obligation-ico.png" /></div>
                                    <span>Obligations</span></a
                                  >
                                </li> -->
                            <!-- <li :class="{'active': current_step==13}"><a href="#" @click="current_step>13 ? current_step=13: null"><div><img src="email-ico.png" /></div><span>Email</span></a></li> -->
                          </ul>
                        </div>
                      </div>
                      <div :class="{ 'd-none': current_step != 2 }" id="step2">
                        <div class="steps-titlebar">
                          <div class="steps-titlebar-text">
                            <div class="d-flex align-items-center">
                              <h2 class="step-tab-title">Create a Scenario to Explore</h2>
                              <div class="hover-info-box">
                                <span class="hover-icon ml-2">
                                  <i class="far fa-question-circle"></i>
                                </span>
                                <div class="hover-info position-right">
                                  <h5 class="hover-info-title fw-700">
                                    All scenario assumptions can be changed and expanded upon directly in the app
                                    dashboard after completion of this initial onboarding.
                                  </h5>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- <h5 class="step-tab-count">Step 1</h5> -->
                        </div>
                        <div class="steps-body">
                          <b-row class="justify-content-center">
                            <b-col md="12" lg="6" class="mb-3 mb-lg-0">
                              <b-card no-header
                                class="no-box-shadow profile-inner-card profile-inner-card-mob border-radius-10 h-100 mystep-2-card">
                                <b-row>
                                  <b-col lg="12">
                                    <div class="row custom-form-control mb-2">
                                      <legend class="col-form-label col-12 col-md-12" for="inline-form-input-name">
                                        5-Digit Zip Code or Area Name
                                      </legend>
                                      <div class="col-12 col-md-12">
                                        <b-form-group class="mb-0" label-for="zip-autocomplete">
                                          <b-form-input id="zip-autocomplete" class="big-input-font" v-model="search"
                                            @input="onInput" @focus="showSuggestions = true" @blur="hideSuggestions"
                                            @keydown="onKeydown" placeholder="Enter / Search Here" autocomplete="off" />
                                          <ul v-if="showSuggestions && suggestions.length"
                                            class="list-group position-absolute suggestionlist "
                                            style="z-index: 1000; max-height: 200px; overflow-y: auto; width: calc(100% - 30px) !important;">
                                            <li v-for="zip_1 in suggestions" :key="zip_1.id"
                                              class="list-group-item list-group-item-action"
                                              @mousedown.prevent="selectZip(zip_1)">
                                              {{ zip_1.area_name }}
                                            </li>
                                          </ul>
                                        </b-form-group>
                                      </div>
                                    </div>
                                  </b-col>
                                </b-row>
                                <b-row>
                                  <b-col lg="12" v-if="selectedZip">
                                    <div class="row custom-form-control mb-3">
                                      <div class="col-12 col-md-12">
                                        <b-form-input
                                          :value="selectedZip && (isZipSelected ? `${selectedZip.zip_code} - ${selectedZip.area_name}` : (selectedZip.area_name || ''))"
                                          placeholder="" disabled
                                          class="position-relative big-input-font"></b-form-input>
                                      </div>
                                    </div>
                                  </b-col>
                                </b-row>
                                <b-row>
                                  <!-- <b-col lg="12">
                                    <div class="row custom-form-control validation-error mb-0"  v-for="(ag,key) in age" :key="key">
                                      <div class="col-12 col-md-12">
                                        <div class="d-flex align-items-center flex-gap-input">
                                          <legend class="col-form-label w-auto" for="inline-form-input-name" v-if="key === 0">
                                            Age of Each Household Member in This Scenario
                                          </legend>
                                          <small v-if="key==0 && age[key] && age[key]<18" class="text-danger"><b>(Must be 18+)</b></small>
                                        </div>
                                      </div>
                                      <div class="col-12 col-md-12 mb-3" >
                                        <div class="d-flex flex-gap-input align-items-start justify-content-justify" :description="ag && ag > 17
                                        ? ''
                                        : '(Scenarios Valid For 18 Or Older)'
                                        ">
                                        <div class="custom-form-control w-100">
                                          <b-form-input :placeholder="key==0? 'Enter Here' : 'Enter Here'" type="text" ref="field_3"
                                            pattern="\d*" v-on:keypress="NumbersOnly" maxlength="3" v-model="age[key]" autocomplete="on"
                                            :formatter="avoidDecimal" class="big-input-font"></b-form-input>
                                            <small v-if="key==0 && age[key] && age[key]<18" class="text-danger">(Scenarios Valid For 18 Or Older)</small>
                                          </div>
                                          <b-button @click="age.push('')" type="button" class="btn-green" v-if="key === 0"><i class="fas fa-plus"></i></b-button>
                                          <b-button v-if="key > 0" @click="age.splice(key, 1)" type="button" class="btn-danger"><i class="fas fa-minus"></i></b-button>
                                        </div>
                                      </div>
                                    </div>
                                  </b-col> -->
                                  <!-- <b-col lg="12">
                                  <div
                                    class="row custom-form-control validation-error mb-0"
                                    v-for="(ag, key) in age"
                                    :key="key"
                                  >
                                    <div class="col-12 col-md-12">
                                      <div class="d-flex align-items-center flex-gap-input">
                                        <legend
                                          class="col-form-label w-auto"
                                          v-if="key === 0"
                                        >
                                          Age of Each Household Member in This Scenario
                                        </legend>
                                        <small
                                          v-if="key == 0 && age[key] && age[key] < 18"
                                          class="text-danger"
                                        ><b>(Must be 18+)</b></small>
                                      </div>
                                    </div>

                                    <div class="col-12 col-md-12 mb-3">
                                      <div class="d-flex align-items-center flex-gap-input">
                                        
                                        <div class="btn-column">
                                          <b-button
                                            v-if="key > 0 && key !== age.length - 1"
                                            @click="removeMember(key)"
                                            type="button"
                                            class="btn-danger"
                                          >
                                            <i class="fas fa-minus"></i>
                                          </b-button>

                                          <b-button
                                            v-else-if="key === age.length - 1"
                                            @click="addMember"
                                            type="button"
                                            class="btn-green"
                                          >
                                            <i class="fas fa-plus"></i>
                                          </b-button>
                                        </div>

                                        <div class="custom-form-control flex-fill">
                                          <b-form-input
                                            placeholder="Enter Here"
                                            type="text"
                                            pattern="\d*"
                                            maxlength="3"
                                            v-on:keypress="NumbersOnly"
                                            v-model="age[key]"
                                            autocomplete="on"
                                            :formatter="avoidDecimal"
                                            class="big-input-font"
                                          ></b-form-input>
                                          <small
                                            v-if="key == 0 && age[key] && age[key] < 18"
                                            class="text-danger"
                                          >(Scenarios Valid For 18 Or Older)</small>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </b-col> -->
                                </b-row>
                              </b-card>
                            </b-col>
                            <!-- <b-col md="12" lg="6" class="mb-3 mb-lg-0">
                              <b-card no-header class="no-box-shadow profile-inner-card border-radius-10 h-100">
                                <b-form-group label="Rent or Buy Your Home?" class="custom-form-control">
                                  <div class="buy-rent-radios">
                                    <b-row>
                                      <b-col cols="6" md="4" lg="4">
                                        <div class="inputGroup">
                                          <input id="rentradio1" type="radio" value="rent" v-model="rentOrOwn"
                                            name="rentOrOwn" />
                                          <label for="rentradio1">Rent</label>
                                        </div>
                                      </b-col>
                                      <b-col cols="6" md="4" lg="4">
                                        <div class="inputGroup">
                                          <input id="buyradio1" type="radio" value="own" v-model="rentOrOwn"
                                            name="rentOrOwn" />
                                          <label for="buyradio1">Buy</label>
                                        </div>
                                      </b-col>
                                    </b-row>
                                  </div>
                                </b-form-group>

                                <b-form-group label="Age of each Household Member"
                                  class="custom-form-control step-slider mb-0 mt-3 mt-md-5">
                                  <vue-slider v-model="household_members" :data="data" :marks="true" :data-value="'id'"
                                    :data-label="'name'" :dot-options="dotOptions"></vue-slider>
                                </b-form-group>
                               
                              </b-card>
                            </b-col> -->
                          </b-row>
                        </div>
                        <div class="steps-footer-action mt-1">
                          <div class="steps-footer-action-left">
                            <div class="back_buttons">
                              <b-button @click="current_step = 1" type="button"
                                class="btn-back-step d-flex align-items-center p-0 mr-2 mr-sm-3">
                                <span class="d-inline-block">
                                  <i class="fas fa-arrow-left"></i>
                                </span>

                                <span class="d-inline-block ml-2">Back</span>
                              </b-button>
                            </div>
                            <!--  <div class="enter-buttons">
                              <b-button
                                type="button"
                                @click="current_step = 3"
                                data-step="3"
                                ref="zip"
                                :disabled="
                                  zip.length < 5 ||
                                  !zip_codes.find(
                                    (item) => item['Zip Code'] === zip
                                  ) ||
                                  rentOrOwn === '' ||
                                  age < 18
                                "
                                class="btn-enter-step"
                              >
                                <span class="mr-sm-2 d-inline-block"> OK </span>
                                <span class="d-none d-sm-inline-block">
                                  <i class="fas fa-check-circle"></i>
                                </span>
                              </b-button>
                              <div class="ok-divider ml-1 ml-lg-2">
                                <span class="or-divider mx-2 mx-sm-3">OR</span>
                                <span class="press-enter">Press Enter ↵</span>
                              </div>
                            </div>-->
                          </div>
                          <div class="steps-footer-action-right w-100">
                            <div class="back_buttons d-flex align-items-center justify-content-end">
                              <b-button type="button" @click="current_step = 3" :disabled="zip.length < 5 ||
                                !zip_codes.find(
                                  (item) => item['Zip Code'] === zip
                                ) ||
                                rentOrOwn === ''" class="btn-next-step">
                                <span class="mr-2 d-inline-block">Next</span>
                                <span class="d-inline-block">
                                  <i class="fas fa-arrow-right"></i>
                                </span>
                              </b-button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div :class="{ 'd-none': current_step != 3 }" id="step3">
                        <div class="steps-titlebar">
                          <div class="steps-titlebar-text">
                            <div class="d-flex align-items-center">
                              <h2 class="step-tab-title">Ages</h2>
                              <!-- <div class="hover-info-box">
                                <span class="hover-icon ml-2">
                                  <i class="far fa-question-circle"></i>
                                </span>
                                <div class="hover-info position-right">
                                  <h5 class="hover-info-title fw-700">
                                    All scenario assumptions can be changed and expanded upon directly in the app
                                    dashboard after completion of this initial onboarding.
                                  </h5>
                                </div>
                              </div> -->
                            </div>
                          </div>
                          <!-- <h5 class="step-tab-count">Step 1</h5> -->
                        </div>
                        <div class="steps-body">
                          <b-row class="justify-content-center">
                            <b-col md="12" lg="6" class="mb-3 mb-lg-0">
                              <b-card no-header
                                class="no-box-shadow profile-inner-card profile-inner-card-mob border-radius-10 h-100 mystep-2-card">
                                <!-- <b-row>
                                  <b-col lg="12">
                                    <div class="row custom-form-control mb-2">
                                      <legend class="col-form-label col-12 col-md-12" for="inline-form-input-name">
                                        5-Digit Zip Code or Area Name
                                      </legend>
                                      <div class="col-12 col-md-12">
                                          <b-form-group class="mb-0" label-for="zip-autocomplete">
                                            <b-form-input
                                              id="zip-autocomplete"
                                              class="big-input-font"
                                              v-model="search"
                                              @input="onInput"
                                              @focus="showSuggestions = true"
                                              @blur="hideSuggestions"
                                              @keydown="onKeydown"
                                              placeholder="Enter / Search Here"
                                              autocomplete="off"
                                            />
                                            <ul
                                              v-if="showSuggestions && suggestions.length"
                                              class="list-group position-absolute w-100"
                                              style="z-index: 1000; max-height: 200px; overflow-y: auto;"
                                            >
                                              <li
                                                v-for="zip_1 in suggestions"
                                                :key="zip_1.id"
                                                class="list-group-item list-group-item-action"
                                                @mousedown.prevent="selectZip(zip_1)"
                                              >
                                                {{ zip_1.area_name }}
                                              </li>
                                            </ul>
                                          </b-form-group>
                                      </div>
                                    </div>
                                  </b-col>
                                </b-row> -->
                                <!-- <b-row>
                                  <b-col lg="12" v-if="selectedZip">
                                    <div class="row custom-form-control mb-3">
                                      <div class="col-12 col-md-12">
                                        <b-form-input :value="selectedZip && (isZipSelected ? `${selectedZip.zip_code} - ${selectedZip.area_name}` : (selectedZip.area_name || ''))" placeholder="" disabled
                                          class="position-relative big-input-font"></b-form-input>
                                      </div>
                                    </div>
                                  </b-col>
                                </b-row> -->
                                <b-row>
                                  <!-- <b-col lg="12">
                                    <div class="row custom-form-control validation-error mb-0"  v-for="(ag,key) in age" :key="key">
                                      <div class="col-12 col-md-12">
                                        <div class="d-flex align-items-center flex-gap-input">
                                          <legend class="col-form-label w-auto" for="inline-form-input-name" v-if="key === 0">
                                            Age of Each Household Member in This Scenario
                                          </legend>
                                          <small v-if="key==0 && age[key] && age[key]<18" class="text-danger"><b>(Must be 18+)</b></small>
                                        </div>
                                      </div>
                                      <div class="col-12 col-md-12 mb-3" >
                                        <div class="d-flex flex-gap-input align-items-start justify-content-justify" :description="ag && ag > 17
                                        ? ''
                                        : '(Scenarios Valid For 18 Or Older)'
                                        ">
                                        <div class="custom-form-control w-100">
                                          <b-form-input :placeholder="key==0? 'Enter Here' : 'Enter Here'" type="text" ref="field_3"
                                            pattern="\d*" v-on:keypress="NumbersOnly" maxlength="3" v-model="age[key]" autocomplete="on"
                                            :formatter="avoidDecimal" class="big-input-font"></b-form-input>
                                            <small v-if="key==0 && age[key] && age[key]<18" class="text-danger">(Scenarios Valid For 18 Or Older)</small>
                                          </div>
                                          <b-button @click="age.push('')" type="button" class="btn-green" v-if="key === 0"><i class="fas fa-plus"></i></b-button>
                                          <b-button v-if="key > 0" @click="age.splice(key, 1)" type="button" class="btn-danger"><i class="fas fa-minus"></i></b-button>
                                        </div>
                                      </div>
                                    </div>
                                  </b-col> -->
                                  <b-col lg="12">
                                    <div class="mb-4 custom-form-control">
                                      <legend class="col-form-label w-auto p-0 mb-1">
                                        Age of Each Household Member in This Scenario
                                      </legend>
                                      <i class="text-muted font-weight-normal">
                                        (Excluding roommates who pay their own bills)
                                      </i>
                                      <small v-if="age[0] && age[0] < 18" class="text-danger d-block mt-1">
                                        <b>(Must be 18+)</b>
                                      </small>
                                    </div>

                                    <div v-for="(ag, key) in age" :key="key" class="mb-3">
                                      <div class="d-flex align-items-center" style="gap: 10px;">
                                        <!-- Minus and Plus Buttons Container -->
                                        <div class="d-flex" style="gap: 8px;">
                                          <!-- Minus Button (only show after first item) -->
                                          <b-button v-if="key > 0" @click="removeMember(key)" type="button"
                                            variant="danger"
                                            style="width: 40px; height: 40px; padding: 0; border-radius: 4px;">
                                            <i class="fas fa-minus"></i>
                                          </b-button>

                                          <!-- Plus Button -->
                                          <b-button @click="addMember" type="button"
                                            style="width: 40px; height: 40px; padding: 0; border-radius: 4px; background-color: #1abc9c; border-color: #1abc9c;">
                                            <i class="fas fa-plus"></i>
                                          </b-button>
                                        </div>

                                        <!-- Age Input -->
                                        <div style="flex: 1;">
                                          <b-form-input class="big-input-font" v-model="age[key]"
                                            placeholder="Type your answer here.." type="text" pattern="\d*"
                                            maxlength="3" @keypress="NumbersOnly" :formatter="avoidDecimal"
                                            autocomplete="on"
                                            style="height: 48px; font-size: 16px; border: 1px solid #d1d5db; border-radius: 6px;">
                                          </b-form-input>
                                          <small v-if="key === 0 && age[key] && age[key] < 18"
                                            class="text-danger d-block mt-1">
                                            (Scenarios Valid For 18 Or Older)
                                          </small>
                                        </div>
                                      </div>
                                    </div>
                                  </b-col>
                                </b-row>
                              </b-card>
                            </b-col>
                            <!-- <b-col md="12" lg="6" class="mb-3 mb-lg-0">
                              <b-card no-header class="no-box-shadow profile-inner-card border-radius-10 h-100">
                                <b-form-group label="Rent or Buy Your Home?" class="custom-form-control">
                                  <div class="buy-rent-radios">
                                    <b-row>
                                      <b-col cols="6" md="4" lg="4">
                                        <div class="inputGroup">
                                          <input id="rentradio1" type="radio" value="rent" v-model="rentOrOwn"
                                            name="rentOrOwn" />
                                          <label for="rentradio1">Rent</label>
                                        </div>
                                      </b-col>
                                      <b-col cols="6" md="4" lg="4">
                                        <div class="inputGroup">
                                          <input id="buyradio1" type="radio" value="own" v-model="rentOrOwn"
                                            name="rentOrOwn" />
                                          <label for="buyradio1">Buy</label>
                                        </div>
                                      </b-col>
                                    </b-row>
                                  </div>
                                </b-form-group>

                                <b-form-group label="Age of each Household Member"
                                  class="custom-form-control step-slider mb-0 mt-3 mt-md-5">
                                  <vue-slider v-model="household_members" :data="data" :marks="true" :data-value="'id'"
                                    :data-label="'name'" :dot-options="dotOptions"></vue-slider>
                                </b-form-group>
                               
                              </b-card>
                            </b-col> -->
                          </b-row>
                        </div>
                        <div class="steps-footer-action mt-1">
                          <div class="steps-footer-action-left">
                            <div class="back_buttons">
                              <b-button @click="current_step = 2" type="button"
                                class="btn-back-step d-flex align-items-center p-0 mr-2 mr-sm-3">
                                <span class="d-inline-block">
                                  <i class="fas fa-arrow-left"></i>
                                </span>

                                <span class="d-inline-block ml-2">Back</span>
                              </b-button>
                            </div>
                            <!--  <div class="enter-buttons">
                              <b-button
                                type="button"
                                @click="current_step = 3"
                                data-step="3"
                                ref="zip"
                                :disabled="
                                  zip.length < 5 ||
                                  !zip_codes.find(
                                    (item) => item['Zip Code'] === zip
                                  ) ||
                                  rentOrOwn === '' ||
                                  age < 18
                                "
                                class="btn-enter-step"
                              >
                                <span class="mr-sm-2 d-inline-block"> OK </span>
                                <span class="d-none d-sm-inline-block">
                                  <i class="fas fa-check-circle"></i>
                                </span>
                              </b-button>
                              <div class="ok-divider ml-1 ml-lg-2">
                                <span class="or-divider mx-2 mx-sm-3">OR</span>
                                <span class="press-enter">Press Enter ↵</span>
                              </div>
                            </div>-->
                          </div>
                          <div class="steps-footer-action-right w-100">
                            <div class="back_buttons d-flex align-items-center justify-content-end">
                              <b-button type="button" @click="current_step = 4" :disabled="zip.length < 5 ||
                                !zip_codes.find(
                                  (item) => item['Zip Code'] === zip
                                ) ||
                                rentOrOwn === '' ||
                                age.length == 0 || age[0] < 18
                                " class="btn-next-step">
                                <span class="mr-2 d-inline-block">Next</span>
                                <span class="d-inline-block">
                                  <i class="fas fa-arrow-right"></i>
                                </span>
                              </b-button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div :class="{ 'd-none': current_step != 4 }" id="step4">
                        <div class="steps-titlebar flex-gap-input">
                          <!-- <div class="d-sm-flex flex-gap-input align-items-center"> -->
                          <h2 class="step-tab-title">Income / Careers</h2>
                          <h5 class="step-tab-count ml-lg-3">{{ selectedZip && (isZipSelected ? `${selectedZip.zip_code}
                            - ${selectedZip.area_name}` : (selectedZip.area_name || '')) }}</h5>
                          <!-- </div> -->
                          <!-- <h5 class="step-tab-count">Step 2</h5> -->
                        </div>
                        <div class="steps-body">
                          <div class="income-method-inner row">
                            <b-col cols="12" md="12" sm="12"
                              :lg="(occupationAIText.length > 0 || occupationAILoad) ? '6' : '12'">
                              <b-row class="align-items-stretch justify-content-center">
                                <div v-for="(income, i) in incomes" :key="i"
                                  class="result-profile-innercard profile-innercard no-box-shadow border-0 bg-transparent"
                                  :style="(occupationAIText.length > 0 || occupationAILoad) ? 'width:50%' : 'width:25%'">
                                  <template>
                                    <div class="home_income p-2">
                                      <div class="tagline mb-2 mb-lg-3 d-flex justify-space-between align-items-center">
                                        <div class="source-count">
                                          <span class="d-inline-block text-source ">
                                            Source
                                            #{{ i + 1 }}
                                          </span>
                                          <!-- <div class="hover-info-box">
                                            <span class="hover-icon ml-2">
                                              <i class="far fa-question-circle"></i>
                                            </span>
                                            <div class="hover-info position-left">
                                              <h5 class="hover-info-title fw-700">More Income sources can be added in the app dashboard</h5>
                                            </div>
                                          </div> -->
                                        </div>
                                        <div class="d-flex justify-space-between align-items-center">
                                          <span v-if="incomes.length > 1" @click="removeIncome(i)"
                                            class="text-danger cursor-pointer far fa-times-circle"></span>
                                        </div>
                                      </div>
                                      <div
                                        class="income-method-type mb-2 flex-md-row flex-sm-row flex-lg-column flex-xl-column justify-space-between align-items-center mystep-4-card">
                                        <div class="inputGroup my-1">
                                          <input type="radio" :name="`income_method_${i}`" class="custom-control-input"
                                            value="2" @change="
                                              incomeChange(i, incomes[i].manual)
                                              " v-model="incomes[i].manual" :id="`grossradioOption${i}`" />
                                          <label :for="`grossradioOption${i}`">
                                            <span class="">Manual Input</span>
                                          </label>
                                        </div>
                                        <div class="inputGroup my-1">
                                          <input type="radio" :name="`income_method_${i}`" class="custom-control-input"
                                            value="1" @change="
                                              incomeChange(i, incomes[i].manual)
                                              " v-model="incomes[i].manual" :id="`incomeradioOption${i}`" />
                                          <label :for="`incomeradioOption${i}`">
                                            <span class="">Occupation</span>
                                          </label>
                                        </div>
                                      </div>
                                      <div class="manually-input-radios">
                                        <template v-if="income.manual == '2'">
                                          <div class="manually-inputGroup-radios mt-lg-3">
                                            <div class="inputGroup mb-2">
                                              <input :id="`weeklyRadio-${i}`" type="radio" value="52"
                                                @click="onSeourceSelect(i)" v-model="incomes[i].freq"
                                                :name="`incomes[${i}].freq`" />
                                              <!-- <span>A</span> -->
                                              <label :for="`weeklyRadio-${i}`">
                                                Weekly
                                              </label>
                                            </div>
                                            <div class="inputGroup mb-2">
                                              <input :id="`2weekRadio-${i}`" type="radio" value="26"
                                                @click="onSeourceSelect(i)" v-model="incomes[i].freq"
                                                :name="`incomes[${i}].freq`" />
                                              <label :for="`2weekRadio-${i}`">
                                                <!-- <span>B</span> -->
                                                Every 2 Weeks
                                              </label>
                                            </div>
                                            <div class="inputGroup mb-2">
                                              <input :id="`permonthRadio-${i}`" type="radio" value="24"
                                                @click="onSeourceSelect(i)" v-model="incomes[i].freq"
                                                :name="`incomes[${i}].freq`" />
                                              <label :for="`permonthRadio-${i}`">
                                                <!-- <span>C</span> -->
                                                Twice Per Month
                                              </label>
                                            </div>
                                            <div class="inputGroup mb-2">
                                              <input :id="`MonthlyRadio-${i}`" type="radio" value="12"
                                                @click="onSeourceSelect(i)" v-model="incomes[i].freq"
                                                :name="`incomes[${i}].freq`" />
                                              <label :for="`MonthlyRadio-${i}`">
                                                <!-- <span>D</span> -->
                                                Monthly
                                              </label>
                                            </div>
                                            <div class="inputGroup mb-2">
                                              <input :id="`quarterlyRadio-${i}`" type="radio" value="4"
                                                @click="onSeourceSelect(i)" v-model="incomes[i].freq"
                                                :name="`incomes[${i}].freq`" />
                                              <label :for="`quarterlyRadio-${i}`">
                                                <!-- <span>E</span> -->
                                                Quarterly
                                              </label>
                                            </div>
                                            <div class="inputGroup mb-2">
                                              <input :id="`semiannuallyRadio-${i}`" type="radio" value="2"
                                                @click="onSeourceSelect(i)" v-model="incomes[i].freq"
                                                :name="`incomes[${i}].freq`" />
                                              <label :for="`semiannuallyRadio-${i}`">
                                                <!-- <span>F</span> -->
                                                Semi-Annually
                                              </label>
                                            </div>
                                            <div class="inputGroup mb-2">
                                              <input :id="`annuallyRadio-${i}`" type="radio" value="1"
                                                @click="onSeourceSelect(i)" v-model="incomes[i].freq"
                                                :name="`incomes[${i}].freq`" />
                                              <label :for="`annuallyRadio-${i}`">
                                                <!-- <span>G</span> -->
                                                Annually
                                              </label>
                                            </div>
                                          </div>

                                          <div class="amount_data mt-3 mb-lg-3 amount-data">
                                            <b-form-group class="custom-form-control mb-0" label="Amount">
                                              <NumberInput :model="incomes[i].amount" ref="input_amount"
                                                v-on:enterEvent="
                                                  enterEvent('finalEmail')
                                                  " @keydown.tab="numberValueChange2" @changeValue="numberValueChange2"
                                                :name="`incomes[${i}].amount`" placeholder="Enter Here"
                                                class="big-input-font" />
                                            </b-form-group>
                                          </div>

                                          <div class="gross-net-home-radios mt-2">
                                            <div class="inputGroup mb-2">
                                              <input type="radio" :name="`radio-inline-${i}`" value="gross"
                                                @click="onSeourceSelect(i, false)" v-model="incomes[i].grossOrNet"
                                                :id="`incomeradioOption-${i}`" />
                                              <label :for="`incomeradioOption-${i}`">
                                                <span class="">Gross</span>
                                              </label>
                                            </div>
                                            <div class="inputGroup">
                                              <input type="radio" :name="`radio-inline-${i}`" value="net"
                                                @click="onSeourceSelect(i, false)" v-model="incomes[i].grossOrNet"
                                                :id="`grossradioOption-${i}`" />
                                              <label :for="`grossradioOption-${i}`">
                                                Net "Take Home"
                                              </label>
                                            </div>
                                          </div>
                                        </template>
                                        <template v-if="incomes[i].manual != '2'">
                                          <!-- <b-row>
                                            <b-col md="12" lg="12">
                                              <div
                                                class="d-flex justify-content-end"
                                              >
                                                <div
                                                  class="hover-info-box occupation-hover-info"
                                                >
                                                  <span
                                                    class="hover-icon d-inline-block ml-2"
                                                  >
                                                    <i
                                                      class="far fa-question-circle"
                                                    ></i>
                                                  </span>
                                                  <div
                                                    v-if="!occupationAILoad"
                                                    class="hover-info position-right"
                                                    style="white-space: pre-line"
                                                    v-html="occupationAIText"
                                                  ></div>
                                                  <div
                                                    v-else
                                                    class="hover-info position-right"
                                                  >
                                                    <div
                                                      class="d-flex flex-column align-items-center justify-content-center"
                                                    >
                                                      <div
                                                        class="loader-ai"
                                                      ></div>
                                                      <p class="mb-0 mt-2">
                                                        Loading, Please Wait...
                                                      </p>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </b-col>
                                          </b-row> -->
                                          <b-row>
                                            <b-col md="12" lg="12">
                                              <div class="custom-form-control">
                                                <div class="d-flex align-items-center">
                                                  <label class="col-form-label">Occupation Selector</label>
                                                  <div v-if="
                                                    incomes[i].manual == '1' &&
                                                    incomes[i].occupation &&
                                                    (occupationAIText.length >
                                                      0 ||
                                                      occupationAILoad)
                                                  " class="hover-info-box occupation-hover-info d-block">
                                                    <span class="hover-icon d-inline-block ml-2">
                                                      <i class="far fa-question-circle"></i>
                                                    </span>
                                                    <div v-if="!occupationAILoad" class="hover-info position-left">
                                                      <div class="mb-3" v-for="(
aidata, i
                                                      ) in occupationAIText" :key="i">
                                                        <div class="">
                                                          <h2>{{ aidata.title }}</h2>
                                                        </div>
                                                        <div class=" ">
                                                          <div class="ai-response-profile-card-body-content mt-2" v-for="(
insights, j
                                                          ) in aidata.detail" :key="j">
                                                            <h3>
                                                              {{ insights.title }}
                                                            </h3>
                                                            <ul class="ai-response-profile-list mt-2">
                                                              <li>
                                                                {{ insights.detail }}
                                                              </li>
                                                            </ul>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div v-else class="hover-info position-left">
                                                      <div
                                                        class="d-flex flex-column align-items-center justify-content-center">
                                                        <div class="loader-ai"></div>
                                                        <p class="mb-0 mt-2">
                                                          Loading, Please Wait...
                                                        </p>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <b-form-group class="mb-lg-2 custom-form-control">
                                                <Multiselect placeholder="Search" v-model="incomes[i].occupation"
                                                  @select="
                                                    levelChange(
                                                      i,
                                                      incomes[i].level,
                                                      incomes[i].occupation,
                                                      true,
                                                      incomes[i].area
                                                    )
                                                    " :options="occupations.map(
                                                      (item) => item.id
                                                    )
                                                      ">
                                                </Multiselect>
                                              </b-form-group>
                                            </b-col>
                                          </b-row>
                                          <b-row>
                                            <b-col md="12" lg="12">
                                              <div
                                                class="flex-gap-input align-items-center justify-content-between d-flex mb-3">
                                                <div class="hover-info-box">
                                                  <span class="hover-icon">
                                                    <i class="far fa-question-circle"></i>
                                                  </span>
                                                  <div class="hover-info position-left">
                                                    <h5 class="hover-info-title fw-700">
                                                      Click on <span class="underline">Career Search</span> to choose
                                                      from 14 primary "Career Clusters".
                                                      This will narrow the list of over 800
                                                      occupations to only those of
                                                      interest to you.
                                                      <!-- Click to choose a "Career Cluster".
                                                      Then select from a list of occupations
                                                      that may be fulfilling for you. -->
                                                      <!-- This simple 10 question survey can help narrow down the list of
                                                      over 800 tracked occupations to just those that are most relevant
                                                      to you. -->
                                                    </h5>
                                                  </div>
                                                </div>
                                                <b-button type="button"
                                                  @click="$bvModal.show('career-fit-2'); activeCareer = i"
                                                  class="btn btn-sm btn-green w-100" style="font-size: 15px;">Career
                                                  Search</b-button>
                                                <b-button type="button" @click="clearIncome(i)"
                                                  class="btn btn-sm btn-danger"
                                                  style="font-size: 15px;">Clear</b-button>
                                              </div>
                                            </b-col>
                                          </b-row>
                                          <b-row>
                                            <b-col md="12" lg="12">
                                              <b-form-group class="custom-form-control mb-4 mt-lg-2"
                                                label="Show Gross Salary Levels For">
                                                <div
                                                  class="area-state-select area-state-select area-disable state-disable nation-disable"
                                                  :ref="`area-${i}`">
                                                  <b-form-radio-group v-model="incomes[i].area" :options="area_level
                                                    " @change="
                                                      levelChange(
                                                        i,
                                                        incomes[i].level,
                                                        incomes[i].occupation,
                                                        true,
                                                        incomes[i].area
                                                      )
                                                      " :name="`salary-lavel-${i}`"
                                                    class="custom-form-control area-state-select-level-radios"></b-form-radio-group>
                                                </div>
                                              </b-form-group>
                                            </b-col>
                                          </b-row>
                                          <b-form-group class="mb-0 mb-lg-2 custom-form-control"
                                            label="Annual Gross Salary Levels">
                                            <b-row>
                                              <b-col md="12">
                                                <b-form-radio-group 
                                                    :disabled="!incomes[i].occupation
                                                    " v-model="incomes[i].level" 
                                                    :options="getAnnualOptions(i)" 
                                                    @change="
                                                      levelChange(
                                                        i,
                                                        incomes[i].level,
                                                        incomes[i].occupation,
                                                        true,
                                                        incomes[i].area
                                                      )
                                                      " :name="`radio-inline-${i}`"
                                                  class="custom-form-control annual-gross-level-radios"
                                                  stacked></b-form-radio-group>
                                              </b-col>
                                            </b-row>
                                          </b-form-group>
                                          <b-row :ref="`amt-${i}`">
                                            <b-col md="12" lg="12">
                                              <b-form-group class="custom-form-control annual-gross-input"
                                                label="Amount(Annual Gross)">
                                                <NumberInput :model="incomes[i].amount" ref="input_amount" @changeValue="numberValueChange2
                                                " @keydown.tab="numberValueChange2" disabled
                                                  :name="`incomes[${i}].amount`" class="big-input-font" />
                                              </b-form-group>
                                            </b-col>
                                          </b-row>
                                          <b-row class="align-items-center">
                                            <b-col md="6">
                                              <label class="text-source mb-lg-0">$ per Hour </label>
                                            </b-col>
                                            <b-col md="6">
                                              <!-- <NumberInput /> -->
                                              <b-form-input aria-disabled="true" disabled aria-readonly="true"
                                                :value="incomes[i].amount && `$${(incomes[i].amount / 2080).toFixed(2)}`"
                                                class="big-input-font"></b-form-input>
                                            </b-col>
                                          </b-row>
                                        </template>
                                      </div>
                                    </div>
                                  </template>
                                </div>
                                <b-col md="12"
                                  :lg="(occupationAIText.length > 0 || occupationAILoad) && (incomes.length > 0) ? '6' : '3'"
                                  class="mb-3 mb-lg-0">
                                  <div v-if="incomes.length < 4" class="add_home_income p-2 h-100">
                                    <div class="tagline mb-2 mb-lg-3 d-flex justify-space-between align-items-center">
                                      <div class="source-count">
                                        <span class="d-inline-block text-source">
                                          Source #{{ incomes.length + 1 }}
                                        </span>
                                      </div>
                                      <div class="d-flex justify-space-between align-items-center"></div>
                                    </div>
                                    <b-card no-header
                                      class="no-box-shadow add-income-source-card income-method-inner-card border-radius-10">
                                      <div class="add-income-source">
                                        <div @click="addIncomeNew()" class="add_more_data">
                                          <i class="fa fa-plus flex-shrink-0 mr-2 mr-md-0"></i>
                                          <h6 class="mb-0 mt-0 mt-md-2">
                                            Add More
                                          </h6>
                                        </div>
                                      </div>
                                    </b-card>
                                  </div>
                                </b-col>
                              </b-row>
                              <b-row>
                                <b-col>
                                  <b-card no-header
                                    class="no-box-shadow monthly-gross-income-inner-card mb-3 mt-0 mt-lg-3 border-radius-10">
                                    <b-row>
                                      <!-- <b-col cols="12" md="12" xl="3"> </b-col> -->
                                      <b-col cols="12" md="12" xl="12">
                                        <template>
                                          <div class="total_monthly_inc text-capitalize text-center text-md-right">
                                            {{incomes.length == incomes.filter(item => item.grossOrNet == 'net').length
                                              ?
                                              'Estimated' :
                                              (incomes.length == incomes.filter(item => item.grossOrNet == 'gross').length
                                                ?
                                                'Total' : 'Estimated'
                                              )}}
                                            Monthly Gross Income
                                            <span class="income-amount">{{
                                              monthly_take_home_input_value
                                            }}</span>
                                          </div>
                                          <div class="total_monthly_inc mt-1 text-capitalize text-center text-md-right">
                                            {{incomes.length == incomes.filter(item => item.grossOrNet == 'net').length
                                              ?
                                              'Total' : 'Estimated'}}
                                            Take-Home Income
                                            <span class="income-amount">{{
                                              netAmountInput
                                            }}</span>
                                          </div>
                                        </template>
                                      </b-col>
                                    </b-row>
                                  </b-card>
                                </b-col>
                              </b-row>
                            </b-col>
                            <b-col cols="12" md="12"
                              :lg="(occupationAIText.length > 0 || occupationAILoad) ? '6' : '12'">
                              <div v-if="!occupationAILoad"
                                class="bg-transparent ai-response-profile-card-outer ai-overflow-y d-flex">
                                <b-card no-header no-body
                                  class="ai-response-profile-card no-box-shadow border-radius-10 border-radius-10 mb-3 mr-2"
                                  v-for="(aidata, i) in occupationAIText" :key="i">
                                  <div class="ai-response-profile-card-header">
                                    <h2>{{ aidata.title }}</h2>
                                  </div>
                                  <div class="ai-response-profile-card-body">
                                    <div class="ai-response-profile-card-body-content"
                                      v-for="(insights, j) in aidata.detail" :key="j">
                                      <h3>{{ insights.title }}</h3>
                                      <ul class="ai-response-profile-list mt-2">
                                        <li>
                                          {{ insights.detail }}
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </b-card>
                              </div>
                              <b-card v-else no-header no-body
                                class="ai-response-profile-card no-box-shadow border-radius-10 mb-3 d-none d-md-block">
                                <div class="ai-response-profile-card-body ai-response-min-height">
                                  <div class="text-center w-100 ai-response-min-height">
                                    <div
                                      class="d-flex flex-column align-items-center justify-content-center ai-response-min-height">
                                      <div class="loader-ai"></div>
                                      <p class="mb-0 mt-2">
                                        Loading, Please Wait...
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </b-card>
                            </b-col>
                          </div>
                        </div>
                        <div class="steps-footer-action mt-1">
                          <div class="steps-footer-action-left">
                            <div class="back_buttons">
                              <b-button @click="current_step = 3" type="button"
                                class="btn-back-step d-flex align-items-center p-0 mr-2 mr-sm-3">
                                <span class="d-inline-block">
                                  <i class="fas fa-arrow-left"></i>
                                </span>
                                <span class="d-inline-block ml-2">Back</span>
                              </b-button>
                            </div>
                            <!-- <div class="enter-buttons">
                              <b-button
                                type="button"
                                @click="current_step = 4"
                                data-step="4"
                                ref="finalEmail"
                                :disabled="
                                  !monthly_take_home_input_value_int > 0
                                "
                                class="btn-enter-step"
                              >
                                <span class="mr-sm-2 d-inline-block"> OK </span>
                                <span class="d-none d-sm-inline-block">
                                  <i class="fas fa-check-circle"></i>
                                </span>
                              </b-button>
                              <div class="ok-divider ml-1 ml-lg-2">
                                <span class="or-divider mx-2 mx-sm-3">OR</span>
                                <span class="press-enter">Press Enter ↵</span>
                              </div>
                            </div> -->
                          </div>
                          <div class="steps-footer-action-right">
                            <div class="back_buttons d-flex align-items-center">
                              <!-- <b-button
                                @click="current_step = 2"
                                type="button"
                                class="btn-back-step p-0 mr-2 mr-sm-3"
                              >
                                <span class="d-none d-sm-inline-block">
                                  <i class="fas fa-arrow-left"></i>
                                </span>
                                <span class="d-inline-block ml-sm-2">Back</span>
                              </b-button> -->
                              <b-button type="button" @click="current_step = 5; checkPeer('other_debt_payments')"
                                :disabled="!monthly_take_home_input_value_int > 0
                                  " class="btn-next-step">
                                <span class="mr-2 d-inline-block">Next</span>
                                <span class="d-none d-sm-inline-block">
                                  <i class="fas fa-arrow-right"></i>
                                </span>
                              </b-button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div :class="{ 'd-none': current_step != 5 }" id="step5">
                        <div class="steps-titlebar">
                          <h2 class="step-tab-title">Housing Type</h2>
                          <!-- <h5 class="step-tab-count">Step 3</h5> -->
                        </div>
                        <div class="steps-body">
                          <b-card no-header no-body
                            class="no-box-shadow rent-mortgage-inner-card mb-3 border-radius-10">
                            <!-- <div class="rent-mortgage-inner-card-header">
                              <h4 class="rent-mortgage-inner-title mb-0">
                                Rent Or Mortgage
                              </h4>
                            </div> -->
                            <div class="rent-mortgage-inner-card-body">
                              <!-- <b-row>
                                  <b-col md="12" lg="12">
                                    <b-form-group class="custom-form-control mb-0" label="Housing Type">
                                      <b-row>
                                        <b-col cols="6" sm="6" md="4" lg="2">
                                          <div class="inputGroup mb-2">
                                            <input id="housingTypeRent" type="radio" value="rent" v-model="housingType"
                                              name="housingType" />
                                            <label for="housingTypeRent">Rent</label>
                                          </div>
                                        </b-col>
                                        <b-col cols="6" sm="6" md="4" lg="2">
                                          <div class="inputGroup mb-2">
                                            <input id="housingTypeBuy" type="radio" value="buy" v-model="housingType"
                                              name="housingType" />
                                            <label for="housingTypeBuy">Buy</label>
                                          </div>
                                        </b-col>
                                      </b-row>
                                    </b-form-group>
                                  </b-col>
                                </b-row> -->

                              <b-form-group label="Housing Type" class="custom-form-control">
                                <div class="buy-rent-radios mystep-5-card">
                                  <b-row>
                                    <b-col cols="6" sm="4" md="3" lg="2">
                                      <div class="inputGroup">
                                        <input id="rentradio1" type="radio" value="rent" v-model="rentOrOwn"
                                          name="rentOrOwn" />
                                        <label for="rentradio1">Rent</label>
                                      </div>
                                    </b-col>
                                    <b-col cols="6" sm="4" md="3" lg="2">
                                      <div class="inputGroup">
                                        <input id="buyradio1" type="radio" value="own" v-model="rentOrOwn"
                                          name="rentOrOwn" />
                                        <label for="buyradio1">Own</label>
                                      </div>
                                    </b-col>
                                  </b-row>
                                </div>
                              </b-form-group>
                            </div>
                            <!-- <div class="rent-mortgage-inner-card-footer text-center text-md-left"></div> -->
                          </b-card>
                        </div>
                        <div class="steps-footer-action mt-1">
                          <div class="steps-footer-action-left">
                            <div class="back_buttons">
                              <b-button @click="current_step = 4" type="button"
                                class="btn-back-step d-flex align-items-center p-0 mr-2 mr-sm-3">
                                <span class="d-inline-block">
                                  <i class="fas fa-arrow-left"></i>
                                </span>

                                <span class="d-inline-block ml-2">Back</span>
                              </b-button>
                            </div>
                          </div>
                          <div class="steps-footer-action-right">
                            <div class="back_buttons d-flex align-items-center">
                              <b-button type="button" @click="current_step = 6; checkPeer('other_debt_payments')"
                                :disabled="!monthly_take_home_input_value_int > 0
                                  " class="btn-next-step">
                                <span class="mr-2 d-inline-block">Next</span>
                                <span class="d-none d-sm-inline-block">
                                  <i class="fas fa-arrow-right"></i>
                                </span>
                              </b-button>
                              <!-- <b-button type="button" @click="mainSubmit()" data-func="mainSubmit"
                                ref="creditDebtPayment" class="btn-next-step">
                                <span class="mr-2 d-inline-block">FINISH</span>
                                <span class="d-inline-block">
                                  <i class="fas fa-check-circle"></i>
                                </span>
                              </b-button> -->
                            </div>
                          </div>
                        </div>
                      </div>
                      <div :class="{ 'd-none': current_step != 6 }" id="step6">
                        <div class="steps-titlebar">
                          <h2 class="step-tab-title">Rent/Mortgage</h2>
                          <!-- <h5 class="step-tab-count">Step 3</h5> -->
                        </div>
                        <div class="steps-body">
                          <b-card no-header no-body
                            class="no-box-shadow rent-mortgage-inner-card mb-3 border-radius-10">
                            <div class="rent-mortgage-inner-card-body mystep-6-card">
                              <b-row>
                                <b-col sm="12" lg="6" xl="6">
                                  <b-form-group label="Monthly Rent or Mortgage Payments"
                                    class="custom-form-control position-relative mb-0"
                                    description="(Include Property Taxes, Homeowners Insurance)">
                                    <span v-if="checkPeerParentValue1" class="edit-peers-amount"
                                      @click="checkPeer('mortgage_and_rent')"><i class="fas fa-pencil-alt"></i></span>
                                    <NumberInput :model="monthlyRent" ref="field_6" v-on:enterEvent="
                                      enterEvent('monthlyRent')
                                      " @changeValue="numberValueChange" @click="updateSharedRent"
                                      class="font-italic big-input-font" name="monthlyRent"
                                      placeholder="Enter here or click dwelling size" />
                                  </b-form-group>
                                  <b-form-group>
                                    <div class="peer-action-buttons">
                                      <!-- <b-button
                                      type="button"
                                      class="btn-purple mr-2"
                                    >
                                      <i class="fas fa-pencil-alt"></i>
                                      <span class="d-inline-block ml-1"
                                        >Edit</span
                                      >
                                    </b-button> -->
                                      <b-button type="button" @click="
                                        checkPeerParent1(),
                                        checkPeer('mortgage_and_rent')
                                        " class="btn-green">
                                        Show Peer Benchmark Amount
                                      </b-button>
                                    </div>
                                  </b-form-group>
                                </b-col>
                                <b-col sm="12" lg="6" xl="6">
                                  <div class="dwelling-size">
                                    <div class="text-center">
                                      <h6 class="text-source">{{ selectedZip && (isZipSelected ?
                                        `${selectedZip.zip_code}
                                        -
                                        ${selectedZip.area_name}` : (selectedZip.area_name || '')) }}</h6>
                                      <p class="text-muted small mb-0">Fair Market Rent or Mortgage Payments Estimate by
                                        # of Bedrooms</p>
                                    </div>

                                    <div
                                      class="dwelling-size-badge flex-gap-input d-flex flex-wrap align-items-center justify-content-center my-4">
                                      <div class="size-badge text-center">
                                        <h6 class="text-dark font-weight-bold mb-1">Studio</h6>
                                        <b-button size="sm" class=" btn-secondary font-weight-bold rounded btn-fair"
                                          :class="{ 'btn-active': selectedDwellingSize === `area_studio` || selectedDwellingSize === `zip_code_studio` }"
                                          @click="handleClick(isZipSelected ? `zip_code_studio` : `area_studio`)"
                                          type="button">
                                          {{ selectedZip && selectedZip[isZipSelected ? `zip_code_studio` :
                                            `area_studio`] &&
                                            usdValue(parseFloat(this.rentOrOwn === "own" ? selectedZip[isZipSelected ?
                                              `zip_code_studio` :
                                              `area_studio`] * 1.33 : selectedZip[isZipSelected ? `zip_code_studio` :
                                                `area_studio`]).toFixed() ||
                                              0) }}
                                        </b-button>
                                      </div>
                                      <div class="size-badge text-center">
                                        <h6 class="text-dark font-weight-bold mb-1">1BR</h6>
                                        <b-button size="sm" class="font-weight-bold rounded btn-fair"
                                          :class="{ 'btn-active': selectedDwellingSize === `area_1br` || selectedDwellingSize === `zip_code_1br` }"
                                          @click="handleClick(isZipSelected ? `zip_code_1br` : `area_1br`)"
                                          type="button">
                                          {{ selectedZip && selectedZip[isZipSelected ? `zip_code_1br` : `area_1br`] &&
                                            usdValue(parseFloat(this.rentOrOwn === "own" ? selectedZip[isZipSelected ?
                                              `zip_code_1br` :
                                              `area_1br`] * 1.33 : selectedZip[isZipSelected ? `zip_code_1br` :
                                                `area_1br`]).toFixed() || 0) }}
                                        </b-button>
                                      </div>
                                      <div class="size-badge text-center">
                                        <h6 class="text-dark font-weight-bold mb-1">2BR</h6>
                                        <b-button size="sm" class="font-weight-bold rounded btn-fair"
                                          :class="{ 'btn-active': selectedDwellingSize === `area_2br` || selectedDwellingSize === `zip_code_2br` }"
                                          @click="handleClick(isZipSelected ? `zip_code_2br` : `area_2br`)"
                                          type="button">
                                          {{ selectedZip && selectedZip[isZipSelected ? `zip_code_2br` : `area_2br`] &&
                                            usdValue(parseFloat(this.rentOrOwn === "own" ? selectedZip[isZipSelected ?
                                              `zip_code_2br` :
                                              `area_2br`] * 1.33 : selectedZip[isZipSelected ? `zip_code_2br` :
                                                `area_2br`]).toFixed() || 0) }}
                                        </b-button>
                                      </div>
                                      <div class="size-badge text-center">
                                        <h6 class="text-dark font-weight-bold mb-1">3BR</h6>
                                        <b-button size="sm" class="font-weight-bold rounded btn-fair"
                                          :class="{ 'btn-active': selectedDwellingSize === `area_3br` || selectedDwellingSize === `zip_code_3br` }"
                                          @click="handleClick(isZipSelected ? `zip_code_3br` : `area_3br`)"
                                          type="button">
                                          {{ selectedZip && selectedZip[isZipSelected ? `zip_code_3br` : `area_3br`] &&
                                            usdValue(parseFloat(this.rentOrOwn === "own" ? selectedZip[isZipSelected ?
                                              `zip_code_3br` :
                                              `area_3br`] * 1.33 : selectedZip[isZipSelected ? `zip_code_3br` :
                                                `area_3br`]).toFixed() || 0) }}
                                        </b-button>
                                      </div>
                                      <div class="size-badge text-center">
                                        <h6 class="text-dark font-weight-bold mb-1">4BR+</h6>
                                        <b-button size="sm" class="font-weight-bold rounded btn-fair"
                                          :class="{ 'btn-active': selectedDwellingSize === `area_4br` || selectedDwellingSize === `zip_code_4br` }"
                                          @click="handleClick(isZipSelected ? `zip_code_4br` : `area_4br`)"
                                          type="button">
                                          {{ selectedZip && selectedZip[isZipSelected ? `zip_code_4br` : `area_4br`] &&
                                            usdValue(parseFloat(this.rentOrOwn === "own" ? selectedZip[isZipSelected ?
                                              `zip_code_4br` :
                                              `area_4br`] * 1.33 : selectedZip[isZipSelected ? `zip_code_4br` :
                                                `area_4br`]).toFixed() || 0) }}
                                        </b-button>
                                      </div>
                                    </div>
                                    <div class="text-center mt-3">
                                      <h6 class="text-secondary mb-0">Click to select dwelling size</h6>
                                    </div>
                                  </div>
                                </b-col>
                              </b-row>
                            </div>
                            <!-- <div class="rent-mortgage-inner-card-footer text-center text-md-left"></div> -->
                          </b-card>
                          <div
                            class="roomate-count-step flex-gap-input d-lg-flex align-items-center justify-content-lg-end text-center mt-4">
                            <h6 class="col-form-label font-weight-bold mb-2 mb-lg-0">
                              # of Other Roommates Sharing Rent or Mortgage Cost:
                            </h6>
                            <div class="d-flex justify-content-center flex-wrap">
                              <b-button v-for="n in [0, 1, 2, 3, 4]" :key="n" size="sm" class="font-weight-bold mx-1"
                                :class="roommatesCount === n ? 'btn-success' : 'btn-secondary'"
                                @click="setRoommates(n)">
                                {{ n }}
                              </b-button>
                            </div>
                          </div>
                        </div>
                        <div class="steps-footer-action mt-1">
                          <div class="steps-footer-action-left">
                            <div class="back_buttons">
                              <b-button @click="current_step = 5" type="button"
                                class="btn-back-step d-flex align-items-center p-0 mr-2 mr-sm-3">
                                <span class="d-inline-block">
                                  <i class="fas fa-arrow-left"></i>
                                </span>

                                <span class="d-inline-block ml-2">Back</span>
                              </b-button>
                            </div>
                            <!-- <div class="enter-buttons">
                              <b-button
                                type="button"
                                @click="mainSubmit()"
                                data-func="mainSubmit"
                                ref="creditDebtPayment"
                                class="btn-enter-step"
                              >
                                <span class="mr-sm-2 d-inline-block"> OK </span>
                                <span class="d-none d-sm-inline-block">
                                  <i class="fas fa-check-circle"></i>
                                </span>
                              </b-button>
                              <div class="ok-divider ml-1 ml-lg-2">
                                <span class="or-divider mx-2 mx-sm-3">OR</span>
                                <span class="press-enter">Press Enter ↵</span>
                              </div>
                            </div> -->
                          </div>
                          <div class="steps-footer-action-right">
                            <div class="back_buttons d-flex align-items-center">
                              <!-- <b-button
                                @click="current_step = 3"
                                type="button"
                                class="btn-back-step p-0 mr-2 mr-sm-3"
                              >
                                <span class="d-none d-sm-inline-block">
                                  <i class="fas fa-arrow-left"></i>
                                </span>
                                <span class="d-inline-block ml-sm-2">Back</span>
                              </b-button> -->
                              <b-button type="button" @click="current_step = 7" ref="creditDebtPayment"
                                class="btn-next-step">
                                <span class="mr-2 d-inline-block">Next</span>
                                <span class="d-inline-block">
                                  <i class="fas fa-arrow-right"></i>
                                </span>
                              </b-button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div :class="{ 'd-none': current_step != 7 }" id="step7">
                        <div class="steps-titlebar">
                          <h2 class="step-tab-title">Vehicle Payments</h2>
                        </div>
                        <div class="steps-body">
                          <b-card no-header no-body
                            class="no-box-shadow monthly-payments-vehicles-inner-card mb-3 border-radius-10">
                            <div class="monthly-payments-vehicles-inner-card-body mystep-7-card">
                              <b-row>
                                <b-col sm="12" lg="6" xl="6">
                                  <b-form-group label="Total Monthly Payments For All Vehicles"
                                    class="custom-form-control position-relative mb-0">
                                    <span class="edit-peers-amount" v-if="checkPeerParentValue2" @click="
                                      checkPeer('vehicle_purchase_and_lease')
                                      "><i class="fas fa-pencil-alt"></i></span>
                                    <NumberInput :model="totalMonthly" ref="field_10" v-on:enterEvent="
                                      enterEvent('totalMonthly')
                                      " @changeValue="numberValueChange" class="font-italic big-input-font"
                                      name="totalMonthly" placeholder="Enter here..." />
                                  </b-form-group>
                                  <b-form-group>
                                    <div class="peer-action-buttons">
                                      <b-button type="button" @click="
                                        checkPeerParent2(),
                                        checkPeer(
                                          'vehicle_purchase_and_lease'
                                        )
                                        " class="btn-green">
                                        Show Peer Benchmark Amount
                                      </b-button>
                                    </div>
                                  </b-form-group>
                                </b-col>
                              </b-row>
                            </div>
                          </b-card>
                        </div>
                        <div class="steps-footer-action mt-1">
                          <div class="steps-footer-action-left">
                            <div class="back_buttons">
                              <b-button @click="current_step = 6" type="button"
                                class="btn-back-step d-flex align-items-center p-0 mr-2 mr-sm-3">
                                <span class="d-inline-block">
                                  <i class="fas fa-arrow-left"></i>
                                </span>

                                <span class="d-inline-block ml-2">Back</span>
                              </b-button>
                            </div>
                            <!-- <div class="enter-buttons">
                              <b-button
                                type="button"
                                @click="mainSubmit()"
                                data-func="mainSubmit"
                                ref="creditDebtPayment"
                                class="btn-enter-step"
                              >
                                <span class="mr-sm-2 d-inline-block"> OK </span>
                                <span class="d-none d-sm-inline-block">
                                  <i class="fas fa-check-circle"></i>
                                </span>
                              </b-button>
                              <div class="ok-divider ml-1 ml-lg-2">
                                <span class="or-divider mx-2 mx-sm-3">OR</span>
                                <span class="press-enter">Press Enter ↵</span>
                              </div>
                            </div> -->
                          </div>
                          <div class="steps-footer-action-right">
                            <div class="back_buttons d-flex align-items-center">
                              <!-- <b-button
                                @click="current_step = 3"
                                type="button"
                                class="btn-back-step p-0 mr-2 mr-sm-3"
                              >
                                <span class="d-none d-sm-inline-block">
                                  <i class="fas fa-arrow-left"></i>
                                </span>
                                <span class="d-inline-block ml-sm-2">Back</span>
                              </b-button> -->
                              <b-button type="button" @click="current_step = 8; checkPeer('health_insurance')"
                                ref="creditDebtPayment" class="btn-next-step">
                                <span class="mr-2 d-inline-block">Next</span>
                                <span class="d-inline-block">
                                  <i class="fas fa-arrow-right"></i>
                                </span>
                              </b-button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div :class="{ 'd-none': current_step != 8 }" id="step8">
                        <div class="steps-titlebar">
                          <h2 class="step-tab-title">Health Insurance</h2>
                        </div>
                        <div class="steps-body">
                          <b-card no-header no-body
                            class="no-box-shadow health-insurance-inner-card mb-3 border-radius-10">
                            <b-row>
                              <b-col sm="12" lg="6" xl="6">
                                <div class="health-insurance-inner-card-body mystep-8-card">
                                  <b-form-group label="Health Insurance Premium (paid out-of-pocket)"
                                    class="custom-form-control mb-0">
                                    <NumberInput :model="healthPremiumAmount" ref="field_20" v-on:enterEvent="
                                      enterEvent('healthPremiumAmount')
                                      " @changeValue="numberValueChange" name="healthPremiumAmount" placeholder="$0"
                                      class="big-input-font" />
                                  </b-form-group>
                                </div>
                              </b-col>
                              <b-col sm="12" lg="12" xl="12">
                                <div class="health-insurance-inner-card-body pt-0">
                                  <p class="mb-0 text-muted small">(Enter $0 If Your Share Of Premium Is Already
                                    Deducted From Your Paycheck -
                                    Or You're Still On Parent's Plan)</p>
                                </div>
                              </b-col>
                            </b-row>
                          </b-card>
                        </div>
                        <div class="steps-footer-action mt-1">
                          <div class="steps-footer-action-left">
                            <div class="back_buttons">
                              <b-button @click="current_step = 7" type="button"
                                class="btn-back-step d-flex align-items-center p-0 mr-2 mr-sm-3">
                                <span class="d-inline-block">
                                  <i class="fas fa-arrow-left"></i>
                                </span>

                                <span class="d-inline-block ml-2">Back</span>
                              </b-button>
                            </div>
                          </div>
                          <div class="steps-footer-action-right">
                            <div class="back_buttons d-flex align-items-center">
                              <b-button type="button" @click="current_step = 9; checkPeer('other_debt_payments')"
                                ref="creditDebtPayment" class="btn-next-step">
                                <span class="mr-2 d-inline-block">Next</span>
                                <span class="d-inline-block">
                                  <i class="fas fa-arrow-right"></i>
                                </span>
                              </b-button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div :class="{ 'd-none': current_step != 9 }" id="step9">
                        <div class="steps-titlebar">
                          <h2 class="step-tab-title">Other Monthly Debt Payments?</h2>
                          <!-- <h5 class="step-tab-count">Step 3</h5> -->
                        </div>
                        <div class="steps-body">
                          <!-- <b-card no-header no-body -->
                          <!-- class="no-box-shadow rent-mortgage-inner-card mb-3 border-radius-10"> -->
                          <!-- <div class="rent-mortgage-inner-card-header">
                              <h4 class="rent-mortgage-inner-title mb-0">
                                Rent Or Mortgage
                              </h4>
                            </div> -->
                          <!-- <div class="rent-mortgage-inner-card-body"> -->
                          <!-- <b-row>
                                  <b-col md="12" lg="12">
                                    <b-form-group class="custom-form-control mb-0" label="Housing Type">
                                      <b-row>
                                        <b-col cols="6" sm="6" md="4" lg="2">
                                          <div class="inputGroup mb-2">
                                            <input id="housingTypeRent" type="radio" value="rent" v-model="housingType"
                                              name="housingType" />
                                            <label for="housingTypeRent">Rent</label>
                                          </div>
                                        </b-col>
                                        <b-col cols="6" sm="6" md="4" lg="2">
                                          <div class="inputGroup mb-2">
                                            <input id="housingTypeBuy" type="radio" value="buy" v-model="housingType"
                                              name="housingType" />
                                            <label for="housingTypeBuy">Buy</label>
                                          </div>
                                        </b-col>
                                      </b-row>
                                    </b-form-group>
                                  </b-col>
                                </b-row> -->

                          <!-- <b-form-group label="Housing Type" class="custom-form-control">
                                  <div class="buy-rent-radios mystep-4-card">
                                    <b-row>
                                      <b-col cols="6" sm="4" md="3" lg="2">
                                        <div class="inputGroup">
                                          <input id="rentradio1" type="radio" value="rent" v-model="rentOrOwn"
                                            name="rentOrOwn" />
                                          <label for="rentradio1">Rent</label>
                                        </div>
                                      </b-col>
                                      <b-col cols="6" sm="4" md="3" lg="2">
                                        <div class="inputGroup">
                                          <input id="buyradio1" type="radio" value="own" v-model="rentOrOwn"
                                            name="rentOrOwn" />
                                          <label for="buyradio1">Buy</label>
                                        </div>
                                      </b-col>
                                    </b-row>
                                  </div>
                                </b-form-group>             -->
                          <!-- <b-row>
                                <b-col sm="12" lg="6" xl="6">
                                  <b-form-group label="Monthly Rent or Mortgage Payments"
                                    class="custom-form-control position-relative mb-0"
                                    description="(Include Property Taxes, Homeowners Insurance)">
                                    <span v-if="checkPeerParentValue1" class="edit-peers-amount"
                                      @click="checkPeer('mortgage_and_rent')"><i class="fas fa-pencil-alt"></i></span>
                                    <NumberInput :model="monthlyRent" ref="field_6" v-on:enterEvent="
                                      enterEvent('monthlyRent')
                                      " @changeValue="numberValueChange" class="font-italic big-input-font"
                                      name="monthlyRent" placeholder="Enter here or click dwelling size" />
                                  </b-form-group>
                                  <b-form-group>
                                    <div class="peer-action-buttons">
                                      <b-button type="button" @click="
                                        checkPeerParent1(),
                                        checkPeer('mortgage_and_rent')
                                        " class="btn-green">
                                        Show Peer Benchmark Amount
                                      </b-button>
                                    </div>
                                  </b-form-group>
                                </b-col>
                                <b-col sm="12" lg="6" xl="6">
                                  <div class="dwelling-size">
                                    <div class="text-center">
                                      <h6 class="text-source">{{selectedZip && (isZipSelected ? `${selectedZip.zip_code} - ${selectedZip.area_name}` : (selectedZip.area_name || ''))}}</h6>
                                      <p class="text-muted small mb-0">Fair Market Rent or Mortgage Payments Estimate by # of Bedrooms</p>
                                    </div>

                                    <div class="dwelling-size-badge flex-gap-input d-flex flex-wrap align-items-center justify-content-center my-4">
                                      <div class="size-badge text-center">
                                        <h6 class="text-dark font-weight-bold mb-1">Studio</h6>
                                        <b-button size="sm" class=" btn-secondary font-weight-bold rounded btn-fair" :class="{'btn-active': selectedDwellingSize===`area_studio` || selectedDwellingSize===`zip_code_studio`}" @click="handleClick(isZipSelected ? `zip_code_studio` : `area_studio`)" type="button">
                                          {{selectedZip && selectedZip[isZipSelected ? `zip_code_studio` : `area_studio`] && usdValue(parseFloat(this.rentOrOwn === "own" ? selectedZip[isZipSelected ? `zip_code_studio` : `area_studio`] * 1.33 : selectedZip[isZipSelected ? `zip_code_studio` : `area_studio`]).toFixed() || 0)}}
                                        </b-button>
                                      </div>
                                      <div class="size-badge text-center">
                                        <h6 class="text-dark font-weight-bold mb-1">1BR</h6>
                                        <b-button size="sm" class="font-weight-bold rounded btn-fair" :class="{'btn-active': selectedDwellingSize===`area_1br` || selectedDwellingSize===`zip_code_1br`}" @click="handleClick(isZipSelected ? `zip_code_1br` : `area_1br`)" type="button">
                                          {{selectedZip && selectedZip[isZipSelected ? `zip_code_1br` : `area_1br`] && usdValue(parseFloat(this.rentOrOwn === "own" ? selectedZip[isZipSelected ? `zip_code_1br` : `area_1br`] * 1.33 : selectedZip[isZipSelected ? `zip_code_1br` : `area_1br`]).toFixed() || 0)}}
                                        </b-button>
                                      </div>
                                      <div class="size-badge text-center">
                                        <h6 class="text-dark font-weight-bold mb-1">2BR</h6>
                                        <b-button size="sm" class="font-weight-bold rounded btn-fair" :class="{'btn-active': selectedDwellingSize===`area_2br` || selectedDwellingSize===`zip_code_2br`}" @click="handleClick(isZipSelected ? `zip_code_2br` : `area_2br`)" type="button">
                                          {{selectedZip && selectedZip[isZipSelected ? `zip_code_2br` : `area_2br`] && usdValue(parseFloat(this.rentOrOwn === "own" ? selectedZip[isZipSelected ? `zip_code_2br` : `area_2br`] * 1.33 : selectedZip[isZipSelected ? `zip_code_2br` : `area_2br`]).toFixed() || 0)}}
                                        </b-button>
                                      </div>
                                      <div class="size-badge text-center">
                                        <h6 class="text-dark font-weight-bold mb-1">3BR</h6>
                                        <b-button size="sm" class="font-weight-bold rounded btn-fair" :class="{'btn-active': selectedDwellingSize===`area_3br` || selectedDwellingSize===`zip_code_3br`}" @click="handleClick(isZipSelected ? `zip_code_3br` : `area_3br`)" type="button">
                                          {{selectedZip && selectedZip[isZipSelected ? `zip_code_3br` : `area_3br`] && usdValue(parseFloat(this.rentOrOwn === "own" ? selectedZip[isZipSelected ? `zip_code_3br` : `area_3br`] * 1.33 : selectedZip[isZipSelected ? `zip_code_3br` : `area_3br`]).toFixed() || 0)}}
                                        </b-button>
                                      </div>
                                      <div class="size-badge text-center">
                                        <h6 class="text-dark font-weight-bold mb-1">4BR+</h6>
                                        <b-button size="sm" class="font-weight-bold rounded btn-fair" :class="{'btn-active': selectedDwellingSize===`area_4br` || selectedDwellingSize===`zip_code_4br`}" @click="handleClick(isZipSelected ? `zip_code_4br` : `area_4br`)" type="button">
                                          {{selectedZip && selectedZip[isZipSelected ? `zip_code_4br` : `area_4br`] && usdValue(parseFloat(this.rentOrOwn === "own" ? selectedZip[isZipSelected ? `zip_code_4br` : `area_4br`] * 1.33 : selectedZip[isZipSelected ? `zip_code_4br` : `area_4br`]).toFixed() || 0)}}
                                        </b-button>
                                      </div>
                                    </div>
                                    <div class="text-center mt-3">
                                      <h6 class="text-secondary mb-0">Click to select dwelling size</h6>
                                    </div>
                                  </div>
                                </b-col>
                              </b-row> -->
                          <!-- </div> -->
                          <!-- </b-card> -->
                          <!-- <b-card no-header no-body
                            class="no-box-shadow monthly-payments-vehicles-inner-card mb-3 border-radius-10">
                            <div class="monthly-payments-vehicles-inner-card-body">
                              <b-row>
                                <b-col sm="12" lg="6" xl="6">
                                  <b-form-group label="Total Monthly Payments For All Vehicles"
                                    class="custom-form-control position-relative mb-0">
                                    <span class="edit-peers-amount" v-if="checkPeerParentValue2" @click="
                                      checkPeer('vehicle_purchase_and_lease')
                                      "><i class="fas fa-pencil-alt"></i></span>
                                    <NumberInput :model="totalMonthly" ref="field_10" v-on:enterEvent="
                                      enterEvent('totalMonthly')
                                      " @changeValue="numberValueChange" class="font-italic big-input-font"
                                      name="totalMonthly" placeholder="Enter here..." />
                                  </b-form-group>
                                  <b-form-group>
                                    <div class="peer-action-buttons">
                                      <b-button type="button" @click="
                                        checkPeerParent2(),
                                        checkPeer(
                                          'vehicle_purchase_and_lease'
                                        )
                                        " class="btn-green">
                                        Show Peer Benchmark Amount
                                      </b-button>
                                    </div>
                                  </b-form-group>
                                </b-col>
                              </b-row>
                            </div>
                          </b-card> -->

                          <!-- <b-card no-header no-body
                            class="no-box-shadow health-insurance-inner-card mb-3 border-radius-10">
                            <b-row>
                              <b-col sm="12" lg="6" xl="6">
                                <div class="health-insurance-inner-card-body">
                                  <b-form-group label="Health Insurance Premium (paid out-of-pocket)"
                                    class="custom-form-control mb-0">
                                    <NumberInput :model="healthPremiumAmount" ref="field_20" v-on:enterEvent="
                                      enterEvent('healthPremiumAmount')
                                      " @changeValue="numberValueChange" name="healthPremiumAmount" placeholder="$0"
                                      class="big-input-font" />
                                  </b-form-group>
                                </div>
                              </b-col>
                              <b-col sm="12" lg="12" xl="12">
                                <div class="health-insurance-inner-card-body pt-0">
                                  <p class="mb-0 text-muted small">(Enter $0 If Your Share Of Premium Is Already Deducted From Your Paycheck - Or You're Still On Parent's Plan)</p>
                                </div>
                              </b-col>
                            </b-row>
                          </b-card> -->
                          <b-card no-header class="no-box-shadow other-debt-payments-inner-card border-radius-10">
                            <b-row>
                              <b-col md="12" lg="12">
                                <!-- <b-form-group class="custom-form-control mb-0" label="Other Monthly Debt Payments?"> -->
                                <b-row class="mystep-9-card">
                                  <b-col cols="6" sm="6" md="4" lg="2">
                                    <div class="inputGroup mb-2">
                                      <input id="obligationPaymentsYes" type="radio" value="yes" v-model="month_debs"
                                        name="obligationPayments" />
                                      <label for="obligationPaymentsYes">Yes</label>
                                    </div>
                                  </b-col>
                                  <b-col cols="6" sm="6" md="4" lg="2">
                                    <div class="inputGroup mb-2">
                                      <input id="obligationPaymentsNo" type="radio" value="no" v-model="month_debs"
                                        name="obligationPayments" />
                                      <label for="obligationPaymentsNo">No</label>
                                    </div>
                                  </b-col>
                                </b-row>
                                <!-- </b-form-group> -->
                              </b-col>
                            </b-row>
                            <b-row :class="{ 'd-none': month_debs != 'yes' }">
                              <b-col md="12" lg="12">
                                <b-card no-header no-body
                                  class="no-box-shadow monthly-payment-card mb-3 border-radius-10">
                                  <div class="monthly-payment-card-header">
                                    <h4 class="monthly-payment-card-title">
                                      Enter Monthly Payment Amounts For
                                    </h4>
                                  </div>
                                  <div class="monthly-payment-card-body">
                                    <h3 class="monthly-payment-hd text-right mb-3 mb-lg-4">
                                      Monthly Payment Amount
                                    </h3>
                                    <b-row class="mb-4 align-items-center">
                                      <b-col cols="6" md="5">
                                        <div class="monthly-payment-form-labels mb-2 mb-lg-1">
                                          <h4 class="monthly-payment-label">
                                            Student Loans
                                          </h4>
                                        </div>
                                      </b-col>
                                      <b-col cols="6" md="3">
                                        <b-button class="mb-2 mb-lg-0 btn-green"
                                          @click="$bvModal.show('student-loan-modal2'); loanComponentView = true">
                                          Help Me Estimate This
                                        </b-button>
                                      </b-col>
                                      <b-col cols="12" md="4">
                                        <div class="flex-gap-input d-flex align-items-center">
                                          <b-form-group class="mb-0 w-100">
                                            <NumberInput :model="studentLoan" v-on:enterEvent="
                                              enterEvent('creditDebtPayment')
                                              " @changeValue="numberValueChange" name="studentLoan" placeholder="$0"
                                              class="text-right big-input-font" />
                                          </b-form-group>
                                          <div class="hover-info-box">
                                            <span class="hover-icon">
                                              <i class="far fa-question-circle"></i>
                                            </span>
                                            <div class="hover-info position-right">
                                              <h5 class="hover-info-title fw-700">
                                                Student loan payments can be a significant part of your future budget.
                                                The "Help Me Estimate
                                                This" calculator is not accurate for everyone's scenario. You should
                                                seek advice from
                                                qualified sources before committing to any student loan.
                                              </h5>
                                            </div>
                                          </div>
                                        </div>
                                      </b-col>
                                    </b-row>
                                    <b-row class="my-0 my-md-3">
                                      <b-col md="8">
                                        <div class="monthly-payment-form-labels mb-2 mb-lg-1">
                                          <h4 class="monthly-payment-label">Credit Card Debt</h4>
                                          <p class="monthly-payment-label-desc">
                                            Exclude New Monthly Charges You Pay
                                            In Full Each Month
                                          </p>
                                        </div>
                                      </b-col>
                                      <b-col md="4">
                                        <b-form-group>
                                          <NumberInput ref="field_14" :model="creditDebtPayment" v-on:enterEvent="
                                            enterEvent('creditDebtPayment')
                                            " @changeValue="numberValueChange" name="creditDebtPayment"
                                            placeholder="$0" class="text-right big-input-font" />
                                        </b-form-group>
                                      </b-col>
                                    </b-row>

                                    <!-- <b-row class="my-0 my-md-3">
                                      <b-col md="8">
                                        <div class="monthly-payment-form-labels mb-2 mb-lg-1">
                                          <h4 class="monthly-payment-label">
                                            Home Equity Line of Credit
                                          </h4>
                                        </div>
                                      </b-col>
                                      <b-col md="4">
                                        <b-form-group>
                                          <NumberInput :model="homeEquityPayment" v-on:enterEvent="
                                            enterEvent('creditDebtPayment')
                                            " @changeValue="numberValueChange" name="homeEquityPayment"
                                            placeholder="$0" class="text-right big-input-font" />
                                        </b-form-group>
                                      </b-col>
                                    </b-row> -->
                                    <!-- <b-row class="my-0 my-md-3">
                                      <b-col md="8">
                                        <div class="monthly-payment-form-labels mb-2 mb-lg-1">
                                          <h4 class="monthly-payment-label">
                                            Alimony or Child Support
                                          </h4>
                                        </div>
                                      </b-col>
                                      <b-col md="4">
                                        <b-form-group>
                                          <NumberInput :model="alimonyPayments" v-on:enterEvent="
                                            enterEvent('creditDebtPayment')
                                            " @changeValue="numberValueChange" name="alimonyPayments" placeholder="$0"
                                            class="text-right big-input-font" />
                                        </b-form-group>
                                      </b-col>
                                    </b-row> -->
                                    <!-- <b-row class="my-0 my-md-3">
                                      <b-col md="8">
                                        <div class="monthly-payment-form-labels mb-2 mb-lg-1">
                                          <h4 class="monthly-payment-label">
                                            Medical Debt Payments
                                          </h4>
                                        </div>
                                      </b-col>
                                      <b-col md="4">
                                        <b-form-group>
                                          <NumberInput :model="childSupportPayments" v-on:enterEvent="
                                            enterEvent('creditDebtPayment')
                                            " @changeValue="numberValueChange" name="childSupportPayments"
                                            placeholder="$0" class="text-right big-input-font" />
                                        </b-form-group>
                                      </b-col>
                                    </b-row> -->
                                    <!-- <b-row class="my-0 my-md-3">
                                      <b-col md="8">
                                        <div class="monthly-payment-form-labels mb-2 mb-lg-1">
                                          <h4 class="monthly-payment-label">
                                            Estimated Tax Payments
                                          </h4>
                                        </div>
                                      </b-col>
                                      <b-col md="4">
                                        <b-form-group>
                                          <NumberInput :model="estimatedTaxPayments" v-on:enterEvent="
                                            enterEvent('creditDebtPayment')
                                            " @changeValue="numberValueChange" name="estimatedTaxPayments"
                                            placeholder="$0" class="text-right big-input-font" />
                                        </b-form-group>
                                      </b-col>
                                    </b-row> -->

                                    <b-row class="my-0 my-md-3">
                                      <b-col md="8">
                                        <div class="monthly-payment-form-labels mb-2 mb-lg-1">
                                          <h4 class="monthly-payment-label">
                                            Other
                                          </h4>
                                        </div>
                                      </b-col>
                                      <b-col md="4">
                                        <b-form-group>
                                          <NumberInput :model="otherDebtPayments" v-on:enterEvent="
                                            enterEvent('creditDebtPayment')
                                            " @changeValue="numberValueChange" name="otherDebtPayments"
                                            placeholder="$0" class="text-right big-input-font" />
                                        </b-form-group>
                                      </b-col>
                                    </b-row>
                                  </div>
                                  <div class="monthly-payment-card-footer ">
                                    <b-row>
                                      <b-col class="text-left">
                                        <span class="total-amount-lavel mr-4">
                                          Peers
                                        </span>
                                        <span class="total-amounts">
                                          {{ totalDebt }}
                                        </span>
                                      </b-col>
                                      <b-col class="text-right">
                                        <span class="total-amount-lavel mr-4">
                                          Total
                                        </span>
                                        <span class="total-amounts">
                                          {{ otherAllDebs }}
                                        </span>
                                      </b-col>
                                    </b-row>
                                  </div>
                                </b-card>
                              </b-col>
                            </b-row>
                          </b-card>
                        </div>
                        <div class="steps-footer-action mt-1">
                          <div class="steps-footer-action-left">
                            <div class="back_buttons">
                              <b-button @click="current_step = 8" type="button"
                                class="btn-back-step d-flex align-items-center p-0 mr-2 mr-sm-3">
                                <span class="d-inline-block">
                                  <i class="fas fa-arrow-left"></i>
                                </span>

                                <span class="d-inline-block ml-2">Back</span>
                              </b-button>
                            </div>
                            <!-- <div class="enter-buttons">
                              <b-button
                                type="button"
                                @click="mainSubmit()"
                                data-func="mainSubmit"
                                ref="creditDebtPayment"
                                class="btn-enter-step"
                              >
                                <span class="mr-sm-2 d-inline-block"> OK </span>
                                <span class="d-none d-sm-inline-block">
                                  <i class="fas fa-check-circle"></i>
                                </span>
                              </b-button>
                              <div class="ok-divider ml-1 ml-lg-2">
                                <span class="or-divider mx-2 mx-sm-3">OR</span>
                                <span class="press-enter">Press Enter ↵</span>
                              </div>
                            </div> -->
                          </div>
                          <div class="steps-footer-action-right">
                            <div class="back_buttons d-flex align-items-center">
                              <!-- <b-button
                                @click="current_step = 3"
                                type="button"
                                class="btn-back-step p-0 mr-2 mr-sm-3"
                              >
                                <span class="d-none d-sm-inline-block">
                                  <i class="fas fa-arrow-left"></i>
                                </span>
                                <span class="d-inline-block ml-sm-2">Back</span>
                              </b-button> -->
                              <b-button type="button" @click="mainSubmit()" data-func="mainSubmit"
                                ref="creditDebtPayment" class="btn-next-step">
                                <span class="mr-2 d-inline-block">FINISH</span>
                                <span class="d-inline-block">
                                  <i class="fas fa-check-circle"></i>
                                </span>
                              </b-button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </form>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <div class="how-to-page mt-5 mt-xl-4" :class="{ 'd-none': !activeTab.includes('How To') }">
      <b-container fluid ref="third_sec" class="custom-container">
        <b-row>
          <b-col xl="8" class="offset-xl-2">
            <b-row>
              <b-col>
                <div class="how-to-page-header text-center mb-3">
                  <h1>
                    How To Use the
                    <span class="text-theme">MyBudgetReport</span>
                    Predictive Budgeting Application
                  </h1>
                  <p class="m-0"><em>Powered by SPENDiD</em></p>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-card no-header no-body class="no-box-shadow how-to-page-card mb-3 border-radius-10">
                  <div class="how-to-page-card-header">
                    <h4 class="how-to-page-header-title m-0">
                      Profile (Step 1)
                    </h4>
                  </div>
                  <div class="how-to-page-card-body">
                    <h4 class="how-to-body-subtitle mb-4">
                      Complete your 
                      <b>“Peer Profile” </b> information by clicking on the
                      <b><u>Start Interview </u></b> button and entering the
                      requested information:
                    </h4>
                    <ul class="how-to-listing">
                      <li>
                        <b>5-digit Home Zip Code </b> where you live or may plan
                        to live
                      </li>
                      <li>Your <b>Age</b></li>
                      <li><b># of Mouths to Feed </b> in your household</li>
                      <li>Whether you <b>Rent or Buy </b> your home</li>
                    </ul>
                    <p>
                      Click on the
                      <span class="text-theme"><b>Next</b></span>
                      button to proceed to the <b>Income</b> page.
                    </p>
                  </div>
                </b-card>
                <b-card no-header no-body class="no-box-shadow how-to-page-card mb-3 border-radius-10">
                  <div class="how-to-page-card-header">
                    <h4 class="how-to-page-header-title m-0">
                      Income (Step 2)
                    </h4>
                  </div>
                  <div class="how-to-page-card-body">
                    <ul class="how-to-listing">
                      <li>
                        For each Income Source, choose either
                        <b>Occupation</b> or <b>Manual Input</b>
                        <ul class="how-to-listing">
                          <li>
                            For <b>Occupation</b> driven <b>Income</b> sources,
                            click or type into the
                            <b>Occupation Selector</b> field to choose from the
                            list of tracked professions.
                            <i>(this feature is helpful for student financial
                              literacy and preparedness training, career
                              counseling, etc..)</i>
                          </li>
                          <li>
                            <p>
                              For the chosen <b>Occupation</b>, select which
                              <b>Annual Gross Salary Level</b> you want to use
                              for your budget scenario.
                              <i>(Low/Median/High)</i>
                            </p>
                            <p>
                              This will automatically populate the
                              <b>Annual Gross Salary</b> amount as well as the
                              <b>Monthly Gross</b> and
                              <b>Estimated Monthly Take Home Income</b>
                              to be budgeted.
                            </p>
                          </li>
                          <li>
                            For <b>Manual Input</b> Income Sources, select
                            <b>the Frequency </b>(how often) each income source
                            is received.
                          </li>
                          <li>
                            <p>
                              For <b>Manual Input</b> Income Sources, enter the
                              dollar <b>Amount</b> of Income for the
                              <b>Frequency</b> selected, and indicate if the
                              <b>Amount</b> is <b>Gross</b> or
                              <b>Net “Take Home”</b>.
                            </p>
                            <p>
                              <i>*These steps can be repeated for additional
                                <b>Income Sources</b> by clicking on</i>
                              <b> +Add More</b>
                            </p>
                          </li>
                        </ul>
                      </li>
                    </ul>
                    <p>
                      Click on the
                      <span class="text-theme fw-700">Next</span>
                      button to proceed to the <b>Expenses</b> page.
                    </p>
                  </div>
                </b-card>
                <b-card no-header no-body class="no-box-shadow how-to-page-card mb-3 border-radius-10">
                  <div class="how-to-page-card-header">
                    <h4 class="how-to-page-header-title m-0">
                      Expense Inputs (Step 3)
                    </h4>
                  </div>
                  <div class="how-to-page-card-body">
                    <ul class="how-to-listing">
                      <li>
                        Enter a known
                        <b>Monthly Rent or Mortgage Payment</b>
                        (including Property Tax, Insurance, and any HOA dues).
                        Optionally the user can
                        <b>Use Peer Benchmark Amount</b> instead.
                      </li>
                      <li>
                        Enter a known
                        <b>Total Monthly Payments for All Vehicles</b>.
                        Optionally the user can <b>Use Peer Benchmark Amount</b>
                        instead.
                      </li>
                      <li>
                        Enter a known monthly
                        <b>Health Insurance Premium Amount</b> that is paid out
                        of Take Home Income. Optionally the user can
                        <b>Use Peer Benchmark Amount</b> instead. (But often
                        this amount should be zero)
                      </li>
                      <li>
                        Choose <b>Yes</b> or <b>No</b> to indicate if the user
                        has
                        <b>Other Monthly Debt Payments.</b>
                        <ul class="how-to-listing">
                          <li>
                            <p>
                              If <b>Yes</b> enter the
                              <b>Monthly Payment Amount</b> for each type listed
                            </p>
                            <p>
                              <i>(Note: Do NOT enter balance owed)</i>
                            </p>
                          </li>
                        </ul>
                      </li>
                    </ul>
                    <p>
                      Click on the
                      <span class="text-theme"><b>FINISH</b></span>
                      button to proceed to the <b>MyBudgetReport</b>
                      application Dashboard.
                    </p>
                  </div>
                </b-card>
                <b-card no-header no-body class="no-box-shadow how-to-page-card mb-3 border-radius-10">
                  <div class="how-to-page-card-header">
                    <h4 class="how-to-page-header-title m-0">
                      MyBudgetReport Application Dashboard
                    </h4>
                  </div>
                  <div class="how-to-page-card-body">
                    <ul class="how-to-listing">
                      <li>
                        After completing the Profile, Income, and Expenses
                        steps, the user lands on the
                        <b>MyBudgetReport App</b> Dashboard with the
                        <b>Results</b>
                        section in view.
                      </li>
                      <li>
                        The previous steps completed have populated all required
                        fields of the <b>Profile</b> and
                        <b>Major Expenses</b> Sections.
                      </li>
                      <li>
                        Use the <b>Profile</b> or <b>Expenses</b> Section
                        Headers at the top of the App to choose a section to
                        view and potentially edit.
                      </li>
                      <li>
                        Click on <b>Results</b> at any time to return to the
                        full Application Dashboard.
                      </li>
                    </ul>
                  </div>
                </b-card>
                <b-card no-header no-body class="no-box-shadow how-to-page-card mb-3 border-radius-10">
                  <div class="how-to-page-card-header">
                    <h4 class="how-to-page-header-title m-0">
                      Profile Section
                    </h4>
                  </div>
                  <div class="how-to-page-card-body">
                    <p class="how-to-para">
                      Users can click on <b>Profile</b> to review and edit any
                      Peer <b>Profile</b> assumptions or <b>Income</b> amounts.
                      Additional <b>Income Sources</b> can also be added.
                    </p>
                  </div>
                </b-card>
                <b-card no-header no-body class="no-box-shadow how-to-page-card mb-3 border-radius-10">
                  <div class="how-to-page-card-header">
                    <h4 class="how-to-page-header-title m-0">
                      Expenses Section
                    </h4>
                  </div>
                  <div class="how-to-page-card-body">
                    <ul class="how-to-listing">
                      <li>
                        <h5 class="fw-700">Major Expenses</h5>
                        These amounts have been populated already during the
                        initial onboarding steps. You can edit them here at any
                        time.
                      </li>
                      <li>
                        <h5 class="fw-700">Monthly Bills</h5>
                        <h6>
                          Edit amounts for any of the six categories of common
                          <b>Monthly Bills</b>
                        </h6>
                        <ul class="how-to-listing mt-3">
                          <li>
                            You may know a more accurate amount than
                            MyBudgetReport’s peer predicted figure.
                          </li>
                          <li>
                            For example, your Utilities-Power Bill might be a
                            known amount different from what MyBudgetReport has
                            forecasted. Just click that <b>Expense Tile</b> and
                            enter your preferred amount, and MyBudgetReport will
                            use it in all other calculations. (Your input
                            amounts will appear as light blue bars)
                          </li>
                          <li>
                            Based on your <b>Profile</b> and known
                            <b>Expense Inputs</b>,
                            <b>MyBudgetReport</b> calculates proposed budget
                            amounts for all Expense Categories for which you did
                            <b><u>NOT</u></b> input a known amount.
                          </li>
                        </ul>
                      </li>
                      <li>
                        <h5 class="fw-700">Other Expenses</h5>
                        <h6>
                          Same logic as for common
                          <b>Monthly Bills</b> section
                        </h6>
                        <ul class="how-to-listing mt-3">
                          <li>
                            <b>Remove</b> any <b>Other Expense</b> categories
                            that don't apply to you.
                          </li>
                          <li>
                            You can easily Restore a Removed Category at any
                            time from the <b>Removed Categories</b> section.
                          </li>
                          <li>
                            Edit any of these
                            <b>Other Expenses</b> categories to a Fixed Amount
                            you know to be more accurate for you.
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </b-card>
                <b-card no-header no-body class="no-box-shadow how-to-page-card mb-3 border-radius-10">
                  <div class="how-to-page-card-header">
                    <h4 class="how-to-page-header-title m-0">Results</h4>
                  </div>
                  <div class="how-to-page-card-body">
                    <h4 class="how-to-body-subtitle mb-4">
                      Once you've completed these simple steps, it's time to
                      review your Results.
                    </h4>
                    <ul class="how-to-listing">
                      <li>
                        Your
                        <b>Monthly Predicted Saving Ability</b> is critically
                        important to know and understand. This is
                        MyBudgetReport’s estimate of the potential monthly
                        surplus (or shortfall) you are likely to experience over
                        time.
                      </li>
                      <li>
                        Your <b>SPENDiD Budget Health Score</b> is an
                        easy-to-understand “grade” of your monthly cash flow
                        health. This <b>Score</b> is also a powerful
                        decision-making metric that can help you understand the
                        level of budget stress a potential expense commitment
                        might cause.
                      </li>
                      <li>
                        This <b>SPENDiD Budget Health Score</b> is calculated
                        based on your <b>Take Home Income</b> and
                        <b>Monthly Predicted Saving Ability</b>.
                      </li>
                      <li>
                        Built on the familiar 1-100 and grades of A-F that
                        everyone understands, obviously the higher your <b>SPENDiD Budget Health Score</b> the better.
                      </li>
                      <li>
                        The scale of the
                        <b>SPENDiD Budget Health Score</b> is built such that a
                        score of exactly 80 indicates a break-even level, or
                        zero dollars of <b>Monthly Predicted Saving Ability</b>.
                      </li>
                      <li>
                        A score above 80 indicates you should be able to have
                        positive cash flow and an ability to add to savings or
                        to reduce debt during most months.
                      </li>
                    </ul>
                  </div>
                </b-card>
                <b-card no-header no-body class="no-box-shadow how-to-page-card mb-3 border-radius-10">
                  <div class="how-to-page-card-header">
                    <h4 class="how-to-page-header-title m-0">
                      Actions You Can Take
                    </h4>
                  </div>
                  <div class="how-to-page-card-body">
                    <h5 class="mb-3 mb-lg-4">
                      With these simple metrics and unique insights from your
                      <b>Results:</b>
                    </h5>
                    <ul class="how-to-listing">
                      <li>
                        If you have a strong <b>SPENDiD Budget Health Score</b>,
                        can you increase your <b>Amount to Savings</b> and start
                        an automated draft to a separate emergency fund account?
                        Or maybe it’s time to increase your 401(k) with holding?
                      </li>
                      <li>
                        If your <b>SPENDiD Budget Health Score</b> seems much
                        lower than you expected,
                        <ul class="how-to-listing">
                          <li>
                            First be sure you’ve entered your Profile, Income
                            and Major Expenses information correctly.
                          </li>
                          <li>
                            Have you removed any expense categories that don’t
                            apply to you? For example, if your share of Health
                            Insurance premiums is already deducted from your
                            paycheck, you should be sure to zero out the amount
                            for this expense category. Don’t have a pet? Then
                            remove that category, and so on.
                          </li>
                        </ul>
                      </li>
                      <li>
                        If you’ve entered a known fixed amount for any common
                        <b>Monthly Bills</b> or <b>Other Expense Category</b>,
                        be sure you entered the amount correctly and with the
                        right payment <b>Frequency</b>.
                      </li>
                      <li>
                        Next, are any of the Fixed Expenses you’ve input higher
                        than your peers? These are shown in the
                        <b>Opportunities</b> section.
                        <ul class="how-to-listing">
                          <li>
                            Click on any of these <b>“Opportunity” bars</b> which will take you to that Expense tile. If
                            the
                            amount you have input is correct, click on the <b>“Ideas”</b> button. This will
                            generate
                            helpful information on
                            that specific topic.
                          </li>
                          <li>
                            For example, if your Rent is much higher than your
                            peers, is it time to consider a lower-cost home or
                            apartment, take in a roommate for a while to share
                            expenses. If your Car Payments category is higher
                            than your peers , is it time to get out from under
                            that new truck payment you regret?
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </b-card>
                <b-card no-header no-body class="no-box-shadow how-to-page-card mb-3 border-radius-10">
                  <div class="how-to-page-card-header">
                    <h4 class="how-to-page-header-title m-0">
                      Your Budget Model (50-30-20)
                    </h4>
                  </div>
                  <div class="how-to-page-card-body">
                    <h5 class="mb-3 mb-lg-4">
                      With these simple metrics and unique insights from your
                      Results:
                    </h5>
                    <ul class="how-to-listing">
                      <li>
                        <b>50%</b> Toward <b>Needs -</b> This budget approach
                        states that you should try to spend no more than 50% of
                        your Take Home Income on “necessary items”. The items in
                        this group of <b>Needs</b> cover the very basics of life
                        including things such as
                        <ul class="how-to-listing">
                          <li>Housing</li>
                          <li>
                            Transportation, <b>including car payments and gas</b>
                          </li>
                          <li>
                            Utilities, <b>like your cell phone, heat, water, gas and
                              trash</b>
                          </li>
                          <li>
                            Groceries <b>(but not eating out in restaurants)</b>
                          </li>
                          <li>
                            Insurance premiums, <b>such as life insurance, health insurance and auto
                              insurance</b>
                          </li>
                          <li>Medical bills</li>
                          <li>Childcare</li>
                          <li>Basic clothing</li>
                          <li>
                            Minimum payments <b>on your debt, such as credit cards, student
                              loans, etc</b>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <b>30%</b> Toward <b>Wants</b> - This is what some
                        people think of as the “fun” category. It includes
                        things you want and would like to have or do but could
                        probably live without if you had to. Included as
                        <b>Wants</b> are things such as
                        <ul class="how-to-listing">
                          <li>Date nights</li>
                          <li>Eating out</li>
                          <li>
                            Entertainment (concerts, plays, sporting events,
                            etc.)
                          </li>
                          <li>Gym membership</li>
                          <li>Hobbies</li>
                          <li>
                            Premium and streaming TV (like HBO and Netflix)
                          </li>
                          <li>
                            Non-essential shopping (new golf clubs, a new Kate
                            Spade purse, etc.)
                          </li>
                          <li>Travel</li>
                        </ul>
                      </li>
                      <li>
                        <b>20%</b> Toward <b>Financial Goals -</b> The next
                        number to think about in this budget formula is 20%
                        toward <b>Financial Goals</b>. This is the money that
                        goes toward things such as:
                        <ul class="how-to-listing">
                          <li>Building an emergency fund</li>
                          <li>Paying off high-interest debt</li>
                          <li>
                            Higher periodic investment into long-term accounts
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </b-card>
                <b-card no-header no-body class="no-box-shadow how-to-page-card mb-3 border-radius-10">
                  <div class="how-to-page-card-header">
                    <h4 class="how-to-page-header-title m-0">
                      Brief, Repeat Engagement With MyBudgetReport Is Critical
                    </h4>
                  </div>
                  <div class="how-to-page-card-body">
                    <ul class="how-to-listing">
                      <li>
                        Plan to spend a few minutes with <b>MyBudgetReport</b> a
                        few times per month to update your known assumptions and
                        to check-in on your <b>SPENDiD Budget Health Score</b> and <b>Predicted Saving Ability</b>.
                      </li>
                      <li>
                        This frequent awareness will help keep you disciplined
                        in your spending and give you greater confidence to take
                        potential steps that are most applicable to YOU.
                      </li>
                      <li>
                        We update our peer database often, which will reflect in
                        your scores. But also, things change for you. For
                        example, you'll want to update MyBudgetReport with
                        changes in your <b>Take-Home Income</b>, a <b>Major Fixed Expense</b>, or an addition to the
                        family!
                      </li>
                      <li>
                        Most importantly, consult with
                        <b>MyBudgetReport</b>  <u>before</u> you make a major
                        expense decision. Try “what-if?” scenarios you’re
                        considering, such as moving to a different zip code,
                        purchasing a vehicle, or taking on a new club
                        membership.
                      </li>
                    </ul>
                  </div>
                </b-card>

                <b-card no-header no-body
                  class="no-box-shadow how-to-page-card how-to-page-card-info mb-3 border-radius-10">
                  <div class="how-to-page-card-header">
                    <h4 class="how-to-page-header-title m-0">
                      And Remember <i class="ml-2 far fa-bell"></i>
                    </h4>
                  </div>
                  <div class="how-to-page-card-body">
                    <p class="mb-0">
                      <b>MyBudgetReport </b> is your “go-to” resource to help
                      you make smarter and more informed financial decisions
                      impacting your debt levels and saving ability. With just a
                      few minutes of monthly engagement, you can enjoy greater
                      financial peace of mind, lower stress, and a healthier and
                      more fulfilling life.
                    </p>
                  </div>
                </b-card>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
    </div>

    <b-modal ref="forget-popup" hide-footer id="forgetpopup" header-text-variant="light" header-border-variant="none">
      <b-row>
        <b-col>
          <b-col class="text-center">
            <img src="footer-logo.png" alt="" />
            <h4 class="mt-4 mb-3">Forget Passoword</h4>
          </b-col>

          <b-form-group class="has-icons-right text-center">
            <!-- <label>Enter your email address.</label> -->
            <b-col class="d-flex align-items-center">
              <b-form-input placeholder="Enter Email" v-model="forget_user_email" type="text" autocomplete="on"
                class="position-relative pr-30 hight50">
              </b-form-input>
              <span class="check icon is-small newspace is-right pr-4">
                <i v-if="!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(forget_user_email)" class="fas fa-times text-danger"></i>
                <i v-else class="fas fa-check text-green"></i>
              </span>
            </b-col>
          </b-form-group>

          <b-form-group class="text-center mt-2">
            <b-col class="d-flex align-items-center">
              <b-button class="btn btn-success green-btn w-100 btnheight50" @click="forgetNow()"
                :disabled="!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(user_email)" aria-controls="cust-core-expense-1">
                Send link on email
              </b-button>
            </b-col>
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal ref="student-loan-modal2" no-close-on-backdrop id="student-loan-modal2"
      class="student-loan-modal font-weight-bold" title="Student Loan Payment Estimator" hide-footer size="lg">
      <loanComponent :isOpen="loanComponentView"
        @close="$bvModal.hide('student-loan-modal2'); loanComponentView = false" @save="saveLoan" />
    </b-modal>
    <b-modal ref="career-fit" id="career-fit-2" class="career-fit-question" hide-footer size="lg">
      <template #modal-header>
        <div
          class="w-100 d-flex justify-content-between justify-content-md-center align-items-center career-fit-2-header p-2">

          <b-button variant="danger" size="sm" class="float-right" @click="$bvModal.hide('career-fit-2')">
            Clear & Go Back
          </b-button>
        </div>
      </template>
      <careerFit :isOpen="careerFitView" @close="careerFitView = false" @chooseOccupationAI="chooseOccupationAI"
        @occupations="onOccupations" :state="zipState" :city="zipCity" :zip="zip" :age="age"
        :selectedZip="selectedZip && (isZipSelected ? `${selectedZip.zip_code} ${selectedZip.area_name}` : (selectedZip.area_name || ''))" />
    </b-modal>


  </div>
</template>

<style>
.amt-loader::after {
  content: '';
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-left: 8px;
  border: 2px solid #ccc;
  border-top-color: #000;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
}

.amount-data legend {
  margin-bottom: 1rem;
  padding-bottom: 0px;
}

.amount-data input {
  /* font-size: 14px !important; */
  font-weight: 500 !important;
  padding: 0.375rem 0.56rem;
  border-radius: 6px;
  font-family: "Poppins", sans-serif !important;
}

.amount-data input::-webkit-input-placeholder {
  color: #3c454c !important;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

#app_steps nav#navbar {
  display: none;
}

.area-disable .annual-gross-level-radios .custom-control:nth-child(1) {
  pointer-events: none;
  background-color: #c6c6c6 !important;
}

.state-disable .annual-gross-level-radios .custom-control:nth-child(2) {
  pointer-events: none;
  background-color: #c6c6c6 !important;
}

.nation-disable .annual-gross-level-radios .custom-control:nth-child(3) {
  pointer-events: none;
  background-color: #c6c6c6 !important;
}

#app_steps .user-detail a {
  display: block;
  margin: 0 auto;
}

#app_steps .user-detail a img {
  left: initial;
  transform: initial;
  -webkit-transform: initial;
}

.text-light span {
  color: #fff;
}

/* #app_steps a.backhome {
    left: 0;
} */

/* Profile Onboard Css Start */
.welcome-card {
  background-color: #fff;
  border-radius: 10px;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,
    rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
}

.darkmode .welcome-card {
  background-color: #151d32;
  border: solid 1px #525b75;
}

.welcome-footer,
.time_duration {
  border-top: solid 1px #e2e2e2;
}

.darkmode .welcome-footer,
.darkmode .time_duration {
  border-top: solid 1px #525b75;
}

.welcome-title,
.create-profile-title {
  font-weight: 700;
  color: #151d32;
}

.skip-interview .welcome-info,
.welcome-info strong {
  color: #000;
}

.darkmode .welcome-title,
.darkmode .create-profile-title,
.darkmode .welcome-info strong,
.darkmode .welcome-info,
.darkmode .skip-interview {
  color: #d0d2e8;
}

.create-profile-title.purple-title {
  color: #7F1583;
}

.darkmode .create-profile-title.purple-title {
  color: #4caf50;
}

.welcome-title,
.create-profile-title {
  font-size: 26px;
}

.welcome-info {
  font-size: 21px;
}

.skip-interview {
  font-size: 18px;
  font-weight: 600;
}

.welcome-info {
  padding: 0 120px;
}

.welcome-body,
.welcome-footer,
.time_duration {
  padding: 20px 0;
}

@media (max-width: 767px) {

  .welcome-body,
  .welcome-footer,
  .time_duration {
    padding: 10px 0;
  }
}

/*#step1 img {
  max-width: 220px;
}*/
#step1 img {
  max-width: 100%;
  border-radius: 10px;
  /* margin-bottom: 10px; */
}

@media (min-width: 1530px) {
  /* #step1 img {
    max-width: 290px;
  }
    */

  .welcome-info {
    padding: 0 80px;
  }

  .welcome-body,
  .welcome-footer {
    padding: 30px 0;
  }

  .welcome-title,
  .create-profile-title {
    font-size: 30px;
  }

  .welcome-info {
    font-size: 20px;
  }
}

@media (max-width: 1200px) {
  .welcome-info {
    padding: 0 60px;
  }

  /* #step1 img {
    max-width: 180px;
  } */
}

@media (max-width: 1024px) {
  .welcome-info {
    padding: 0 40px;
    font-size: 18px;
  }
}

@media (max-width: 540px) {
  /* #step1 img {
    max-width: 160px;
  } */

  .welcome-info {
    padding: 0 15px;
  }

  .welcome-title,
  .create-profile-title {
    font-size: 18px;
  }

  .welcome-info {
    font-size: 14px;
  }
}

/* .form-control.form-control-lg */
.form-control,
.custom-select {
  background-color: #f8f8ff !important;
  border: 1px solid #dedede !important;
  font-weight: 600 !important;
  color: #000 !important;
}

.steps-body .income-method-inner .form-control,
.steps-body .income-method-inner .multiselect__tags,
.add-fudget-form .form-control,
.add-fudget-form .custom-select,
.multiple-blocks .form-control,
.multiple-blocks .custom-select {
  background-color: #fff !important;
}

.darkmode .steps-body .income-method-inner .form-control,
.darkmode .steps-body .income-method-inner .multiselect__tags,
.darkmode .form-control,
.darkmode .custom-select,
.darkmode .add-fudget-form .form-control,
.darkmode .add-fudget-form .custom-select {
  background-color: #151d32 !important;
  border: 1px solid #43495a !important;
  color: #fff !important;
}

.darkmode .cal-card .form-control {
  background-color: initial !important;
  border: initial !important;
  /* color: initial !important; */
}

/* .darkmode .cal-card .form-group .form-control:focus,
.darkmode .cal-card .form-group .form-control{
  color: #fff !important;
} */

.custom-form-control .col-form-label {
  font-weight: 600 !important;
  font-size: 18px !important;
  color: #303360 !important;
}



.darkmode .custom-form-control .col-form-label {
  color: #d0d2e8 !important;
}

.steps-card {
  background-color: #fff;
  border-radius: 10px;
  -webkit-box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,
    rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,
    rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
  border: solid 1px #eee;
}

.profile-inner-card {
  background-color: #fff;
}

.darkmode .profile-inner-card {
  background-color: rgb(11, 15, 28);
  border: 1px solid rgb(82, 91, 117);
}

.darkmode .steps-card {
  background-color: #151d32;
  border: solid 1px #555f79;
}

.steps-titlebar {
  background-color: #f4f4f4;
}

.darkmode .steps-titlebar {
  background-color: #292f45;
}

.steps-titlebar {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.step-tab-title,
.health-insurance-card-title,
.rent-mortgage-inner-title,
.monthly-payments-vehicles-inner-title {
  font-size: 20px;
  color: #000;
}

@media (min-width: 1530px) {

  .step-tab-title,
  .health-insurance-card-title,
  .rent-mortgage-inner-title,
  .monthly-payments-vehicles-inner-title {
    font-size: 24px;
  }
}

.darkmode .step-tab-title,
.darkmode .health-insurance-card-title,
.darkmode .rent-mortgage-inner-title,
.darkmode .monthly-payments-vehicles-inner-title {
  color: #d0d2e8;
}

.step-tab-title,
.step-tab-count {
  margin: 0;
  font-weight: 600;
}

.step-tab-count {
  font-size: 16px;
  color: #3f4e76;
}

.darkmode .step-tab-count {
  color: #d0d2e8;
}

.steps-header,
.steps-body,
.steps-titlebar,
.steps-footer-action {
  padding-left: 20px;
  padding-right: 20px;
}

.steps-titlebar {
  padding-top: 10px;
  padding-bottom: 10px;
}

.steps-header,
.steps-body,
.steps-footer-action {
  padding-top: 15px;
  padding-bottom: 15px;
}

@media (min-width: 1530px) {

  .steps-header,
  .steps-body,
  .steps-footer-action {
    padding-top: 20px;
    padding-bottom: 20px;
  }

  .steps-titlebar {
    padding-top: 15px;
    padding-bottom: 15px;
  }
}

.steps-footer-action {
  border-top: 1px solid rgba(0, 0, 0, 0.125);
}

.darkmode .steps-footer-action {
  border-top: 1px solid #555f79;
}

.enter-buttons,
.steps-footer-action {
  display: flex;
  align-items: center;
}

.steps-footer-action {
  justify-content: space-between;
}

.or-divider,
.press-enter,
.btn-enter-step,
.btn-back-step,
.btn.btn-back-step,
.btn-next-step,
.btn.btn-next-step,
.btn-enter-step,
.btn.btn-enter-step {
  font-size: 18px;
  font-weight: 600;
  font-family: "Poppins", sans-serif !important;
}

@media only screen and (max-width: 767px) {

  .or-divider,
  .press-enter,
  .btn-enter-step,
  .btn-back-step,
  .btn.btn-back-step,
  /* .btn-next-step, */
  /* .btn.btn-next-step, */
  .btn-enter-step,
  .btn.btn-enter-step {
    font-size: 14px !important;
  }
}

.or-divider {
  color: #a9a9a9;
}

.press-enter {
  color: #3f4e76;
}

.darkmode .press-enter {
  color: #d0d2e8;
}

.btn.btn-enter-step,
.btn.btn-next-step {
  border-radius: 100px;
}

.btn.btn-enter-step

/* .btn.btn-next-step  */
  {
  padding: 0.275rem 1rem;
}

@media only screen and (max-width: 767px) {
  .btn.btn-enter-step

  /* .btn.btn-next-step  */
    {
    padding: 0.275rem 0.6rem !important;
    line-height: 1.2;
  }
}

.btn-back-step.btn-secondary:focus,
.btn-back-step,
.btn.btn-back-step,
.btn.btn-back-step:hover,
.btn.btn-secondary:not(:disabled):not(.disabled):active {
  background-color: transparent;
  border-color: transparent;
  color: #3f4e76;
}

.darkmode .btn-back-step,
.darkmode .btn.btn-back-step {
  color: #b0b0b0;
}

.btn-next-step,
.btn.btn-next-step,
.btn.btn-next-step:hover,
.btn-enter-step,
.btn.btn-enter-step,
.btn.btn-enter-step:hover {
  color: #fff;
  background-color: #0fc3b1;
  border-color: #0fc3b1;
  box-shadow: rgb(0 0 0 / 10%) 0px 3px 12px 0px;
}

.btn.btn-next-step,
.btn.btn-next-step:disabled,
.btn-next-step:hover,
.btn.btn-next-step:hover,
.btn-enter-step:hover,
.btn.btn-enter-step:hover {
  color: #fff;
  background-color: #0fc3b1;
  border-color: #0fc3b1;
}


.btn.btn-enter-step:not(:disabled):not(.disabled):active,
.btn.btn-next-step:not(:disabled):not(.disabled):active {
  color: #fff;
  background-color: #0fc3b1;
  border-color: #0fc3b1;
}

.steps-body .income-method-inner {
  border-radius: 10px;
  background-color: #f9f8f8;
  border: solid 1px #c9c9c9;
}

.darkmode .hover-info-box .hover-info {
  background-color: #151d32;
  border: solid 1px #43495a;
  color: #d0d2e8;
}

.text-source {
  color: #303360;
  font-size: 18px;
  font-weight: 600;
}

.darkmode .source-count .hover-icon i,
.darkmode .text-source {
  color: #d0d2e8;
}

.text-frequency {
  color: #696973;
  font-size: 14px;
  font-weight: 400;
}

.darkmode .text-frequency {
  color: #b0b0b0;
}

.add_more_data {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

@media (max-width: 767px) {
  .add_more_data {
    flex-direction: row;
  }

  .steps-card .back_buttons,
  .steps-card .steps-footer-action {
    justify-content: start !important;
  }

  .steps-card .steps-footer-action {
    gap: 20px;
  }
}

.add_more_data i {
  font-size: 30px;
  padding: 0;
  border-radius: 100px;
  border: 2px solid #16cfbc;
  color: #16cfbc;
  width: 70px;
  height: 70px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  display: -webkit-flex;
  -webkit-align-items: center;
  -webkit-justify-content: center;
}

@media (max-width: 767px) {
  .add_more_data i {
    font-size: 18px;
    width: 40px;
    height: 40px;
  }
}

.darkmode .add_more_data i {
  background-color: #525b75;
  border: 2px solid #787c86;
  color: #fff;
}

.add_more_data h6 {
  display: block;
  width: 100%;
  text-align: center;
  font-size: 20px;
  color: #303360;
  margin-top: 20px;
}

.darkmode .add_more_data h6 {
  color: #d0d2e8;
}

.annual-gross-level-radios .custom-control.custom-radio {
  margin-bottom: 10px;
}

.income-method-inner-card {
  background-color: #fff;
}

.income-method-inner-card {
  height: calc(100% - 44px);
}

.darkmode .income-method-inner-card {
  background: #4b4b64;
  border: 1px solid #4b4b64;
}

.darkmode .income-method-inner {
  background: #090729;
  border: 1px solid #525b75;
  color: #cfdaf9;
}

/* .append-design .area-disable .custom-form-control .custom-control label, .append-design .state-disable .custom-form-control .custom-control label, .append-design .nation-disable .custom-form-control .custom-controllabel{
  background: #fff;
  color: #eee;
  pointer-events: none;
}
.area-disable .custom-form-control .custom-control:nth-child(1) input,.state-disable .custom-form-control .custom-control:nth-child(2) input,.nation-disable .custom-form-control .custom-control:nth-child(3) input{
  display: none;
} */
.add-income-source {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  cursor: pointer;
}

.monthly-payment-card {
  background-color: #fff;
}

.darkmode .monthly-payment-card {
  background-color: rgb(12, 19, 37);
  border: 1px solid rgb(82, 91, 117);
}

.monthly-payment-card-title {
  font-size: 18px;
  font-weight: 600;
  color: #303360;
}

.monthly-payment-label {
  font-size: 16px;
  font-weight: 500;
  color: #303360;
}

@media (max-width: 767px) {

  .monthly-payment-card-title,
  .monthly-payment-label {
    font-size: 14px;
  }
}

.darkmode .career-fit-2-header .modal-tilte,
.darkmode .monthly-payment-card-title,
.darkmode .monthly-payment-label {
  color: #d0d2e8;
}

.monthly-payment-card-title,
.monthly-payment-label,
.monthly-payment-label-desc,
.monthly-payment-hd {
  margin: 0;
}

.monthly-payment-label-desc {
  color: #696973;
  font-size: 14px;
  font-weight: 400;
}

@media (max-width: 767px) {
  .monthly-payment-label-desc {
    font-size: 13px;
  }
}

.darkmode .monthly-payment-label-desc {
  color: #a3a3a3;
}

.monthly-payment-hd {
  font-size: 18px;
  color: #303360;
  font-weight: 600;
}

@media (max-width: 767px) {
  .monthly-payment-hd {
    font-size: 16px;
  }
}

.darkmode .monthly-payment-hd {
  color: #d0d2e8;
}

.monthly-payment-card-header,
.monthly-payment-card-body,
.monthly-payment-card-footer {
  padding-top: 15px;
  padding-bottom: 15px;
}

.monthly-payment-card-header,
.monthly-payment-card-body,
.monthly-payment-card-footer {
  padding-left: 20px;
  padding-right: 20px;
}

.monthly-payment-card-body {
  background-color: #f9f8f8;
}

.darkmode .monthly-payment-card-body {
  background-color: rgb(12, 19, 37);
  /* border: 1px solid rgb(82, 91, 117); */
  color: rgb(207, 218, 249);
}

.monthly-payment-card-header {
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}

.darkmode .monthly-payment-card-header {
  border-bottom: 1px solid #555f79;
}

.monthly-payment-card-body .form-control {
  background-color: #fff !important;
}

.other-debt-payments-inner-card {
  background-color: #fff;
}

.darkmode .other-debt-payments-inner-card {
  background-color: #292f45;
  border: solid 1px #555f79;
}

.form-control:disabled,
.form-control[readonly] {
  background-color: #e9ecef !important;
  color: #495057 !important;
}

.darkmode .monthly-payment-card-body .form-control,
.darkmode .profile-inner-card .form-control {
  background-color: rgb(42, 48, 64) !important;
  border: 1px solid rgb(82, 91, 117) !important;
  color: rgb(207, 218, 249) !important;
}

.darkmode .form-control:disabled,
.darkmode .form-control[readonly] {
  background-color: #252b3c !important;
  border: 1px solid #43495a !important;
  color: #d0d0d0 !important;
}

.monthly-payment-card-footer {
  border-top: 1px solid rgba(0, 0, 0, 0.125);
}

.darkmode .monthly-payment-card-footer {
  border-top: 1px solid #555f79;
}

.total-amount-lavel,
.total-amounts {
  font-size: 24px;
  font-weight: 600;
}

.darkmode .flex-gap-input .hover-info-box i,
.darkmode .text-muted {
  color: #a6afb6 !important;
}

.header-nav .navbar-brand img {
  max-height: 86px
}

@media (max-width: 767px) {
  .header-nav .navbar-brand img {
    max-height: 48px;
  }
}

.darkmode .header-nav .navbar-brand .logo-w,
.header-nav .navbar-brand .logo-d {
  display: inline-block
}

.darkmode .header-nav .navbar-brand .logo-d,
.header-nav .navbar-brand .logo-w {
  display: none
}


@media (max-width: 767px) {

  .total-amount-lavel,
  .total-amounts {
    font-size: 16px;
  }
}

.total-amount-lavel {
  color: #303360;
}

.darkmode .total-amount-lavel {
  color: #e9e9e9;
}

.total-amounts {
  color: #0fc3b1;
}

.cursor-pointer {
  cursor: pointer;
}

.validation-error .form-text {
  color: #f00 !important;
}

.health-insurance-inner-card-header,
.rent-mortgage-inner-card-header,
.monthly-payments-vehicles-inner-card-header {
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}

.rent-mortgage-inner-card-footer,
.monthly-payments-vehicles-inner-card-footer {
  border-top: 1px solid rgba(0, 0, 0, 0.125);
}

.darkmode .health-insurance-inner-card-header,
.darkmode .rent-mortgage-inner-card-header,
.darkmode .monthly-payments-vehicles-inner-card-header {
  border-bottom: 1px solid #43495a;
}

.darkmode .rent-mortgage-inner-card-footer,
.darkmode .monthly-payments-vehicles-inner-card-footer {
  border-top: 1px solid #43495a;
}

.health-insurance-inner-card-body,
.health-insurance-inner-card-header,
.rent-mortgage-inner-card-body,
.rent-mortgage-inner-card-header,
.rent-mortgage-inner-card-body,
.rent-mortgage-inner-card-footer,
.monthly-payments-vehicles-inner-card-body,
.monthly-payments-vehicles-inner-card-header,
.monthly-payments-vehicles-inner-card-footer {
  padding: 1.25rem;
}

.darkmode .health-insurance-inner-card,
.darkmode .rent-mortgage-inner-card,
.darkmode .monthly-payments-vehicles-inner-card {
  background-color: rgb(12, 19, 37);
  border: 1px solid rgb(82, 91, 117);
  color: rgb(207, 218, 249);
}

.darkmode .health-insurance-inner-card .form-control,
.darkmode .rent-mortgage-inner-card .form-control,
.darkmode .monthly-payments-vehicles-inner-card .form-control {
  background-color: rgb(12, 19, 37);
  border: 1px solid rgb(82, 91, 117);
  color: rgb(207, 218, 249);
}

.darkmode .steps-body.text-muted {
  color: #979ca2 !important;
}

.edit-peers-amount {
  background: #ffffff;
  border: solid 1px #eee;
  color: #3d4561;
}

.darkmode .edit-peers-amount {
  background: #3d4561;
  border: solid 1px #555f79;
  color: #ffff;
}

.edit-peers-amount {
  width: 30px;
  height: 30px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  padding: 4px;
  position: absolute;
  top: 4px;
  right: 10px;
  cursor: pointer;
}

.peer-action-buttons {
  margin-top: 15px;
}

@media (min-width: 992px) {
  .peer-action-buttons {
    margin-top: 20px;
  }

  .create-profile-action .btn-green.btn-xl {
    font-size: 22px;
    padding: 1rem 2rem;
    border: solid 4px #61cf00 !important;
  }
}

@media (max-width: 767px) {

  /* .app_steps {
    margin-top: 4rem !important;
  } */
  .create-profile-action .btn,
  .instruction-tooltip .btn {
    font-size: 0.8rem;
  }

  .instruction-tooltip .hover-info-box .position-right {
    right: 50%;
    left: 60%;
    transform: translate(-68%, 0px);
  }

  .inputGroup {
    margin: 4px 0;
  }

  .step-tab-title {
    font-size: 16px;
  }

  .steps-header,
  .steps-body,
  .steps-footer-action,
  .monthly-payment-card-header,
  .monthly-payment-card-body,
  .monthly-payment-card-footer {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .steps-header,
  .steps-body,
  .steps-titlebar,
  .steps-footer-action,
  .monthly-payment-card-header,
  .monthly-payment-card-body,
  .monthly-payment-card-footer {
    padding-left: 10px;
    padding-right: 10px;
  }

  .other-debt-payments-inner-card .card-body,
  .health-insurance-inner-card-body,
  .health-insurance-inner-card-header,
  .rent-mortgage-inner-card-body,
  .rent-mortgage-inner-card-header,
  .rent-mortgage-inner-card-body,
  .rent-mortgage-inner-card-footer,
  .monthly-payments-vehicles-inner-card-body,
  .monthly-payments-vehicles-inner-card-header,
  .monthly-payments-vehicles-inner-card-footer,
  .profile-inner-card .card-body {
    padding: 0.6rem;
  }

  /* .custom-form-control .col-form-label, */
  .step-tab-count

  /* .form-control,*/
  .custom-select {
    font-size: 13px !important;
  }

  .profile-inner-card-mob .form-control-mob,
  .form-control-mob {
    display: flex !important;
    justify-content: space-between;
    gap: 10px;
  }

  .profile-inner-card-mob .form-control-mob .col-form-label,
  .form-control-mob .col-form-label {
    width: 50%;
    float: left;
  }

  .profile-inner-card-mob .form-control-mob>div,
  .form-control-mob>div,
  .form-control-mob>.form-control {
    width: 48%;
  }
}

.suggestionlist .list-group-item {
  font-size: 14px !important;
  padding: 10px 10px !important;
}

.big-input-font {
  font-size: 1.3rem !important;
  height: calc(1.5em + 0.75rem + 8px) !important;
}

.career-fit-2-header .btn-danger {
  position: absolute;
  right: 5px;
}

.underline {
  text-decoration: underline;
}

.flex-gap-input {
  gap: 8px;
  /* Space between button and input */
}

.btn-column {
  width: 42px;
  /* Same width for all buttons to align vertically */
  display: flex;
  justify-content: center;
  align-items: center;
}

.btn-green {
  background-color: #28a745;
  border: none;
  color: #fff;
}

.btn-danger {
  background-color: #dc3545;
  border: none;
  color: #fff;
}

.big-input-font {
  /* font-size: 1rem; */
  height: 38px;
}

@media (max-width: 767px) {
  .big-input-font {
    font-size: 16px !important;
  }

  .career-fit-2-header .btn-danger {
    position: relative;
    right: 0;
  }
}

.quick-start {
  position: relative;
}

@media (min-width: 1181px) {

  .walkthrough-btn,
  .quick-start-btn {
    position: absolute !important;
    bottom: 0;
  }

  .walkthrough-btn {
    right: -205px;
  }

  .quick-start-btn {
    left: -168px;
  }
}

/* 
.append-design .state-disable .custom-control-input:checked~.custom-control-label,
.append-design .area-disable .custom-control-input:checked~.custom-control-label,
.append-design .nation-disable .custom-control-input:checked~.custom-control-label{
    background: #fff !important;
    color: #eee !important;
    pointer-events: none !important;
}
.darkmode .append-design .state-disable .custom-control-input:checked~.custom-control-label,
.darkmode .append-design .area-disable .custom-control-input:checked~.custom-control-label,
.darkmode .append-design .nation-disable .custom-control-input:checked~.custom-control-label{
    background-color: #151d32 !important;
    border: solid 1px #7E44A9 !important;
    color: #3c445b !important;
} */
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
